/**
 * @file 英文话术
 * @author zhujialu
 */
define(function (require, exports) {
    'use strict'

    /**
     * =================================================
     * User Role
     * =================================================
     */

    exports.USER_ROLE_TEACHER = 'Teacher'

    exports.USER_ROLE_STUDENT = 'Student'

    exports.USER_ROLE_GUEST = 'Guest'

    exports.USER_ROLE_ASSISTANT = 'TA'

    exports.USER_ROLE_SPECIAL_GUEST = 'Special Guest'

    exports.USER_ASSISTANT_NUMBER = 'TA ${number}'

    /**
     * =================================================
     * Teacher Status
     * =================================================
     */

    exports.TEACHER_UNKNOW = 'Teacher not in Classroom'

    exports.TEACHER_IN = 'Teacher Entered Classroom'

    exports.TEACHER_OUT = 'Teacher Left Classroom'

    exports.TEACHER_AUDIO_ON = 'Mic ON'

    exports.TEACHER_AUDIO_OFF = 'Mic OFF'

    exports.TEACHER_VIDEO_ON = 'Camera ON'

    exports.TEACHER_VIDEO_OFF = 'Camera OFF'

    /**
     * =================================================
     * User Status
     * =================================================
     */

    exports.USER_OUT = 'Left Classroom'

    exports.USER_AUDIO_ON = 'Mic ON'

    exports.USER_AUDIO_OFF = 'Mic OFF'

    exports.USER_VIDEO_ON = 'Camera ON'

    exports.USER_VIDEO_OFF = 'Camera OFF'

    /**
     * =================================================
     * Self Status
     * =================================================
     */

    exports.SELF_AUDIO_ON = 'Mic ON'

    exports.SELF_AUDIO_OFF = 'Mic OFF'

    exports.SELF_VIDEO_ON = 'Camera ON'

    exports.SELF_VIDEO_OFF = 'Camera OFF'

    /**
     * =================================================
     * Video Quality
     * =================================================
     */

    exports.VIDEO_QUALITY_LOW = 'Fluent'

    exports.VIDEO_QUALITY_MEDIUM = 'SD'

    exports.VIDEO_QUALITY_HIGH = 'HD'

    exports.VIDEO_QUALITY_SUPER = 'SHD'

    exports.VIDEO_QUALITY_720P = '720P'

    exports.VIDEO_QUALITY_1080P = '1080P'

    /**
     * =================================================
     * Baijiacloud Terminal Type
     * =================================================
     */

    exports.END_TYPE_PC_BROWSER_BJY = 'PC Browser'

    exports.END_TYPE_PC_CLIENT_BJY = 'PC Client'

    exports.END_TYPE_MAC_CLIENT_BJY = 'Mac Client'

    exports.END_TYPE_MOBILE_BROWSER_BJY = 'Mobile Browser'

    exports.END_TYPE_MOBILE_XIAOCHENGXU = 'Wechat mini program'

    exports.END_TYPE_MOBILE_APPLE_BJY = 'Apple App'

    exports.END_TYPE_MOBILE_ANDROID_BJY = 'Android App'

    exports.END_TYPE_MINI_PROGRAM_BJY = 'Mini Program'

    exports.END_TYPE_WEBRTC_BJY = 'Can Speak'

    exports.END_TYPE_UNKNOWN_BJY = 'Unknown'

    /**
     * =================================================
     * Audio and Video Link Status
     * =================================================
     */

    exports.AV_PLAY_STATUS_CONNECTING = 'Connecting...'

    exports.AV_PLAY_STATUS_FAIL = 'Connection Failed'

    exports.AV_PLAY_STATUS_BUFFERING = 'Buffering Data...'

    /**
     * =================================================
     * Shortcut Key
     * =================================================
     */

    exports.SHORTCUT_EXIT_FULLSCREEN = 'To Exit Fullscreen Press Esc Button'

    /**
     * =================================================
     * Button
     * =================================================
     */

    exports.BUTTON_SUBMIT = 'Confirm'

    exports.BUTTON_CLOSE = 'Close'

    exports.BUTTON_CANCEL = 'Cancel'

    exports.BUTTON_ACCEPT = 'Agree'

    exports.BUTTON_REJECT = 'Reject'

    exports.BUTTON_REFRESH = 'Refresh'

    exports.BUTTON_TRY_REFRESH = 'Try Refresh'

    exports.BUTTON_CLOSE_ROOM = 'StopLive'

    exports.BUTTON_REENTER = 'Re-enter'

    exports.BUTTON_LEAVE = 'Exit Classroom'

    exports.BUTTON_START_CLASS = 'Start'

    exports.BUTTON_START_CLASS_FOR_SELL = 'Start'

    exports.BUTTON_END_CLASS = 'End'

    exports.BUTTON_END_CLASS_FOR_SELL = 'End'

    exports.BUTTON_LEAVE_CLASS_AND_REMOVE_ALL = 'Leave and Remove Users'

    exports.BUTTON_END_CLASS_AND_REMOVE_ALL = 'End and Remove Users'

    exports.BUTTON_STOP_RTMP_PUSH = 'End Push'

    exports.BUTTON_PLAY_MEDIA = 'Media'

    exports.BUTTON_START_RECORD_CLASS = 'Start'

    exports.BUTTON_RECORD_CLASS = 'Record Class'

    exports.BUTTON_STOP_RECORD_CLASS = 'Stop Recording'

    exports.BUTTON_RESTART_RECORD_CLASS = 'Continue Recording'

    exports.BUTTON_RECORD_FULLSCREEN = 'Fullscreen Recording'

    exports.BUTTON_RECORD_AREA = 'Area Recording'

    exports.BUTTON_START_SCREEN_SHARE = 'Share Screen'

    exports.BUTTON_DESKTOP_SHARE = 'Screen Share'

    exports.BUTTON_AREA_SHARE = 'Area Share'

    exports.BUTTON_PROGRAM_SHARE = 'Program Share'

    exports.BUTTON_QUESTION_ANSWER = 'Q&A'

    exports.BUTTON_EXAM = 'Exam'
    exports.BUTTON_END_EXAM = 'End Exam'

    exports.BUTTON_STOP_SCREEN_SHARE = 'Finish'

    exports.BUTTON_RECORD_SETTINGS = 'Recording Settings'

    exports.BUTTON_THIRD_PUSH = 'Push FLow Service'

    exports.BUTTON_FORBID_MIC = 'Mute All'

    exports.BUTTON_CANCEL_FORBID_MIC = 'Cancel Mute'

    exports.BUTTON_SURVEY = 'Test'

    exports.BUTTON_LOTTERY = 'lottery'

    exports.BUTTON_ANSWER = 'Answer'

    exports.BUTTON_DEBUG = 'Adjust'

    exports.BUTTON_TIMER = 'Timer'

    exports.BUTTON_RED_PACKET = 'Credit Reward Game'

    exports.BUTTON_ENTER_FULLSCREEN = 'Fullscreen'

    exports.BUTTON_EXIT_FULLSCREEN = 'Exit Fullscreen'

    exports.BUTTON_OPEN_CAMERA = 'Turned OFF'

    exports.BUTTON_CLOSE_CAMERA = 'Turned ON'

    exports.BUTTON_OPEN_MIC = 'Turned OF'

    exports.BUTTON_CLOSE_MIC = 'Turned ON'

    exports.BUTTON_SPEAK_APPLY = 'Raise Hand'

    exports.BUTTON_SPEAK_APPLY_CANCEL = 'Cancel'

    exports.BUTTON_END_SPEAK = 'End'

    exports.BUTTON_MANAGE_DOCUMENT = 'Manage'

    exports.BUTTON_ADD_DOCUMENT = 'Add'

    exports.BUTTON_REMOVE_DOCUMENT = 'Remove'

    exports.BUTTON_DELETE_DOCUMENT = 'Delete'

    exports.BUTTON_SUBMIT_DOCUMENT = 'Confirm Choice'

    exports.BUTTON_ADD_DOCUMENT_FORM_NETDESK = 'Database Choice'

    exports.BUTTON_UPLOAD_DOCUMENT = 'Upload'

    exports.BUTTON_SEND_MESSAGE = 'Send'

    exports.BUTTON_GIFT = 'Give Drink'

    exports.BUTTON_EDIT_NOTICE = 'Edit Notice'

    exports.BUTTON_SAVE_NOTICE = 'Save Notice'

    exports.BUTTON_SWITCH_GIFT = 'Switch Drink'

    exports.BUTTON_SEND_GIFT_TO_TEACHER = 'Send Teacher Gift'

    exports.BUTTON_FORBID_USER_SEND_MESSAGE = 'Forbid Talking'

    exports.BUTTON_UNFORBID_USER_SEND_MESSAGE = 'Allow Talking'

    exports.BUTTON_SURVEY_ADD_OPTION = 'Add Options'

    exports.BUTTON_NEED = 'Need'

    exports.BUTTON_NO_NEED = 'No Need'

    exports.BUTTON_REPLY_SUBMIT = 'Confirm'

    exports.BUTTON_MINIMIZE = 'Minimize'

    exports.BUTTON_HELP = 'Help'

    exports.BUTTON_ASSISTANT_LINK = 'TA Link'

    exports.BUTTON_JOIN_USERLIST = 'Student List'

    exports.BUTTON_ATTENTION_DETECTION = 'Attention Detection'

    exports.BUTTON_GEN_LINK = 'Generate Link'

    exports.BUTTON_COPY_LINK = 'Copy'

    exports.BUTTON_COPY_LINK_SUCC = 'Success'

    exports.BUTTON_COMMENT = 'Comment'

    exports.BUTTON_DETECT = 'Examine'

    exports.BUTTON_MORE = 'More'

    exports.BUTTON_NEXT_STEP = 'Next Step'

    exports.BUTTON_COMPLETE = 'Complete'

    exports.BUTTON_COMMENT_SUBMIT = 'Submit Comment'

    exports.BUTTOM_COMMENT_SEND = 'Comment Teacher'

    exports.BUTTON_COMMENT_CANCEL = 'No Comment'

    exports.BUTTON_SHOW_LOGS = 'Show Logs'

    exports.BUTTON_HIDE_LOGS = 'Hide Logs'

    exports.BUTTON_RETURN = 'Return'

    exports.BUTTON_SERVER_ROUTE = 'Route'

    exports.BUTTON_SERVER_SUGGEST = 'Suggested Route'

    exports.BUTTON_SERVER_BACKUP = 'Backup Route'

    exports.BUTTON_SWITCH_TO_ONLINE = 'Appear'

    exports.BUTTON_SWITCH_TO_OFFLINE = 'Disappear'

    exports.BUTTON_MODIFY = 'Modify'

    exports.BUTTON_UNFORBID_ALL = 'Allow Speaking'

    exports.BUTTON_COMMENT_REQ_MORE = 'See More'

    exports.BUTTON_COMMENT_NO_MORE = 'No More'

    exports.BUTTON_UPGRADE_CLIENT = 'Download Updates'

    exports.BUTTON_USE_GUIDE = 'Broadcasting Assistant Guide'

    exports.BUTTON_SWITCH_OPEN = 'ON'

    exports.BUTTON_SWITCH_CLOSE = 'OFF'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_ME = 'About Me'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_TEACHER = 'About Teacher'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_ALL = 'All'

    exports.BUTTON_SETTING_MORE_DETAIL = 'More Setting'

    exports.BUTTON_BARRAGE_ON = 'Barrage On'

    exports.BUTTON_BARRAGE_OFF = 'Barrage Off'

    exports.BUTTON_SYSTEM_SOUND = 'System Sound'

    exports.BUTTON_SWITCH_LAYOUT = 'Layout'

    exports.BUTTON_FORBID_RAISE_HAND_OFF = 'Allow Hand'

    exports.BUTTON_FORBID_RAISE_HAND_ON = 'Forbid Hand'

    exports.BUTTON_SHOP = 'Shopping Cart'

    exports.BUTTON_SELL_VIDEO_LAYOUT = 'Pure Video Template'

    exports.BUTTON_SELL_PPT_LAYOUT = 'PPT Sales Template'

    exports.BUTTON_FORBID_STUDENT_RAISE_HAND_OFF = 'Allow Student Hand'

    exports.BUTTON_FORBID_STUDENT_RAISE_HAND_ON = 'Forbid Student Hand'

    exports.BUTTON_HOMEWORK = 'Homework'

    exports.BUTTON_CONFIRM_CANCEL_SCREEN_SHARE_BITRATE_CHANGE = 'I Know'

    exports.BUTTON_CONFIRM_OK_SCREEN_SHARE_BITRATE_CHANGE = 'Reopen Share'

    exports.BUTTON_TOGGLE_VIDEO_AND_DOC = 'Change Screen'

    exports.BUTTON_MAIN_SCREEN_NOTICE = 'Main Screen Notice'

    exports.BUTTON_ASSISTANT_OPTIONS = 'Assistant operation'

    exports.BUTTON_USER_AUTH_INFO = 'View permissions'

    exports.BUTTON_REPORT = 'Report'

    exports.BUTTON_REWARD_RANKING = 'Reward Ranking'

    exports.BUTTON_RUSH_TO_ANSWER = 'Rush To Answer'

    exports.BUTTON_TRANSFER_CLASS_START = 'Start broadcasting'

    exports.BUTTON_TRANSFER_CLASS_END = 'End broadcast'

    exports.BUTTON_GIFT_ANIMATION = 'Gift effects'

    exports.BUTTON_HIDE_GIFT_ANIMATION = 'Shielding effect'

    exports.BUTTON_SHOW_GIFT_ANIMATION = 'Display effects'

    exports.BUTTON_REWARDS = 'Reward'

    exports.BUTTON_REWARDS_STATISTICS = 'Reward statistics'

    exports.BUTTON_VIDEO_LAYOUT = 'Custom streaming'

    exports.BUTTON_LUCKY_BAG = 'Lucky bag'

    exports.BUTTON_CASH_WITHDRAW = 'Withdrawal'

    exports.BUTTON_ON_OFF_STAGE = 'OnOff Stage'

    exports.BUTTON_ACTIVITY = 'activity'

    exports.BUTTON_MESSAGE_CHECK = 'Chat review'

    exports.BUTTON_TURN_OFF_ALL_USERS = 'Turn off all users'

    /**
     * =================================================
     * Label
     * =================================================
     */

    exports.TAB_ALL_USER_LIST = 'Users'

    exports.TAB_ACTIVE_USER_LIST = 'Speakers'

    exports.TAB_CHAT = 'Chat'

    exports.TAB_ANSWER_LIST = 'Q&A'

    exports.TAB_RESEARCH_GROUP = 'Research'

    exports.TAB_USER_LIST_HIDE = 'Users'

    exports.TAB_CLASS_STARTED = 'Living...'

    exports.TAB_TIME_SORT = 'Time Sort'

    exports.ANSWER_SORT_TYPE_SUBMIT = 'Sort By Submission Time'

    exports.ANSWER_SORT_TYPE_OPERATE = 'Sort By Operation Time'

    /**
     * =================================================
     * Ordinary Reminders
     * =================================================
     */

    exports.INFO_CLASS_START = 'Class Starts'

    exports.INFO_CLASS_END = 'Class Ends'

    exports.INFO_SPEAK_APPLY_TIMEOUT = 'No Response from Teacher. Handraising Cancelled.'

    exports.INFO_SPEAK_INVITE_TIMEOUT = '${userName} No Response or Old Client. Invitation Cancelled'

    exports.INFO_SPEAK_OPEN_TIMEOUT = '${userName}No Response or Old Client. Speaking Cancelled'

    exports.INFO_SPEAK_OPEN_SUCCESS = '${userName} Speaking Open. Check at Speaking List'

    exports.INFO_HAS_BEEN_OPENED_SPEAKING = 'Host Arranged Your Speaking'

    exports.INFO_HAS_BEEN_OPENED_WEBMIC = 'Host Turned on Your Microphone'

    exports.INFO_HAS_BEEN_CLOSED_WEBMIC = 'Host Turned off Your Microphone'

    exports.INFO_HAS_BEEN_OPENED_WEBCAM = 'Host Turned on Your Camera'

    exports.INFO_HAS_BEEN_CLOSED_WEBCAM = 'Host Turned off Your Camera'

    exports.INFO_OPEN_WEBCAM_FAILED = 'Webcamera Failed. Click to Retry'

    exports.INFO_WEAR_EARPHONE_WHEN_SPEAKING = 'To Avoid Echo, Please Use Earphone'

    exports.INFO_RECEIVE_MESSAGE = 'New Message'

    exports.INFO_SPEAK_INVITE_ACCEPT = '${userName} Speaking Allowed'

    exports.INFO_SPEAK_INVITE_REJECT = '${userName} Speaking Refused'

    exports.INFO_SPEAK_APPLY_ACCEPT = 'Teacher Allowed your Speaking'

    exports.INFO_SPEAK_APPLY_REJECT = 'Teacher Refused your Speaking'

    exports.INFO_END_SPEAK_BY_TEACHER = 'Teacher Ended your Speaking'

    exports.INFO_DEVICE_IS_STARTING = 'Audio and Video Devices Starting. Please Wait.'

    exports.INFO_CAN_NOT_DO_BEFORE_END_SETTINGS = 'Cannot Proceed Before Finishing Setup.'

    exports.INFO_CAN_NOT_DO_BEFORE_START_CLASS_FOR_TEACHER = 'Please Click Start Class Button.'

    exports.INFO_CAN_NOT_OPEN_CAMERA_AND_MIC = 'Teacher Forbid You Open Camera and Mic'

    exports.INFO_CAN_NOT_DO_BEFORE_START_CLASS_FOR_STUDENT = 'Class Not Started'

    exports.INFO_CAN_NOT_DO_BEFORE_APPLY = 'Raise Hand to Speak'

    exports.INFO_NO_AVAILABLE_CAMERA = 'No Available Camera'

    exports.INFO_NO_AVAILABLE_MIC = 'No Available Mic'

    exports.INFO_FORBID_SEND_MESSAGE_TO_OPERATOR = 'Chat Forbidden'

    exports.INFO_UNFORBID_SEND_MESSAGE_TO_OPERATOR = 'Chat Allowed'

    exports.INFO_FORBID_SEND_MESSAGE_TO_TARGET = 'Chat Forbidden by Teacher'

    exports.INFO_FORBID_SEND_MESSAGE_END = 'Chat Forbiddance Removed'

    exports.INFO_CLIENT_AUTO_UPGRADE = 'Old Client Version. Upgrading...'

    exports.INFO_CLIENT_NOT_SUPPORT = 'Unsupported terminal type, please use the latest version of client to watch'

    exports.INFO_SURVEY_REPLY_RIGHT = 'Congratulations. Right Answer'

    exports.INFO_SURVEY_REPLY_WRONG = 'Oops. Wrong Answer...'

    exports.INFO_SURVEY_REPLY_FREE = 'No Answer Set for this Question'

    exports.INFO_SURVEY_NO_QUESTION = '“No Question. Teacher May Have Stated Orally.”'

    exports.INFO_SURVEY_OPTION_HINT = 'Click to Edit Options'

    exports.INFO_SURVEY_CHOOSE_OPTION = '<span class="arrow">↙</span> Tick to Choose Answer'

    exports.INFO_SURVEY_SELF_CHOOSE = 'Your Choice: '

    exports.INFO_COMMENT_SUCC = 'Comment Success'

    exports.INFO_COMMENT_BEFORE_CLASS = 'Comment Later'

    exports.INFO_APPLY_SPEAK_WOULD_DELAY_SOUND = 'Using Webpage Version May Cause Audio Delay'

    exports.INFO_SPEAK_INVITE_DENY
        = 'Server Reject Your Inviting, Because Audio And Video Concurrency Has Reached An Upper Limit'

    exports.INFO_MEDIA_PUBLISH_DENY
        = 'Server Reject Your Applying, Because Audio And Video Concurrency Has Reached An Upper Limit'

    exports.INFO_CAN_NOT_CLOSE_CAMERA = 'This Route does not have Close Video Function'

    // exports.INFO_SWITCH_SERVER_SUCCESS = 'Switched to ${0}';

    exports.INFO_SWITCH_SERVER_SUCCESS = 'Switched'

    exports.INFO_FORBID_ALL = 'All Speaking Forbidden'

    exports.INFO_UNFORBID_ALL = 'All Forbiddance Removed'

    exports.INFO_FORBID_GROUP_ALL = 'Self Group All Speaking Forbidden'

    exports.INFO_UNFORBID_GROUP_ALL = 'Self Group All Forbiddance Removed'

    exports.INFO_SELF_ABROAD_TIPS
        = 'We Noticed You are Abroad. Overseas Network Stableness Cannot be Assured.<br/>'
        + 'Please Recheck to Ensure your Network Speed to Visit China Mainland Sites.'

    exports.INFO_TEACHER_ABROAD_TIPS
        = 'Teacher is Abroad. Due to Complicated Overseas Network Conditions，<br/>'
        + 'Audio and Video May be Unstable. Please Understand.'

    exports.INFO_OPEN_CAMERA = '${userRole} Camera ON. Loading Data.'

    exports.INFO_OPEN_ASSIST_CAMERA = '${userRole} Auxiliary Camera ON. Loading Data.'

    exports.INFO_CLOSE_CAMERA = 'Camera OFF'

    exports.INFO_OPEN_MIC = '${userRole} Mic ON. Loading Data.'

    exports.INFO_CLOSE_MIC = 'Mic OFF'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_SHARE_PLAY
        = 'Please Close Screen Sharing and Player. Stop Transponding Third-Party Flow.'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_CLOUD_RECORD = 'Cannot Switch Uplink Type while Cloud Recording'

    exports.INFO_CAN_NOT_OPEN_BEAUTIFY_DENOISE = 'Cannot Open Beauty Function under HD, SD, 1080P Modes'

    exports.INFO_CAN_NOT_OPEN_BEAUTIFY_DENOISE = 'Cannot Open Beauty Function under HD, SD, 720P, 1080P Modes'

    exports.INFO_CLOUD_RECORD_START = 'Cloud Recording ON'

    exports.INFO_CLOUD_RECORD_STOP = 'Cloud Recording OFF'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_THIRD_PUSH
        = 'Before Screen Sharing, Please Stop Transponding Third-party Push.'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_PLAY_FILE = 'Before Screen Sharing, Please Stop MediaPlayer.'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_CLOSE_SCREEN_SHARE = 'Before Playing File, Please Stop Screen Sharing.'

    exports.INFO_PLAY_LOCAL_MEDIA_FILE = 'Play Local File.'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_BEFORE_CLOSE_THIRD_PUSH
        = 'Before Playing Local File, Please Stop Transponding Third-party Push'

    exports.INFO_CAN_NOT_THIRD_PUSH_BEFORE_CLOSE_SCREEN_SHARE
        = 'Before Transponding Third-party Push, Please Stop Screen Sharing.'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_WHEN_COLLECT_SYSTEM_SOUND
        = 'Can\'t Play Local File after Collecting System Sound'

    exports.INFO_CAN_NOT_COLLECT_SYSTEM_SOUND_BEFORE_CLOSE_MEDIA_FILE_PLAY
        = 'Can\'t Collect System Sound after Playing Local File'

    exports.CONFIRM_STOP_ASSIST_CAMERA_BEFORE_MEDIA_PLAY
        = '< b > do you want to turn on media playback? < / b > turning on media playback will turn off the secondary camera.'

    exports.CONFIRM_STOP_MEDIA_PLAY_BEFORE_OPEN_ASSIST_CAMERA
        = '< b > do you want to turn on the secondary camera? < / b > turning on the secondary camera will turn off media playback.'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_BEFORE_CLOSE_COLLECT_SYSTEM_SOUND
        = 'Before Playing Local File, Please Stop Collecting System Sound'

    exports.INFO_CAN_NOT_COLLECT_SYSTEM_SOUND_BEFORE_CLOSE_PLAY_LOCAL_MEDIA_FILE
        = 'Please Close the Media Playing Window before Collecting System Sound'

    exports.INFO_CAN_NOT_THIRD_PUSH_BEFORE_CLOSE_SHARE_DESKTOP
        = 'Before Transponding Third-party Push, Please Stop Screen Sharing.'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START = 'Generating Playback. Cannot Continue Cloud Recording.'

    exports.INFO_CLOUD_RECORD_START_COUNT_WARNING = 'Frequent pausing or stop may affect playback quality. Please try again later.'

    exports.INFO_GET_PLAYBACK_STATUS_FAIL = 'Get playback generating status fail, please try again.'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_TIP
        = '<p class="large">Immediately Generate Playback?</p> <p class="error">(Will Start Transcoding after Choosing "Generate Playback Now". You Can\'t Continue Cloud Recording for Current Class Later.)</p>'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_TIP_LONG_TERM = '<p class="large">Immediately Generate Playback?</p> '

    exports.INFO_SEND_IMAGE_POST_DATA_ERROR = 'Data Parsing Error'

    exports.INFO_CAN_NOT_DETECT_DEVICE_DURING_SPEAKING = 'Please Stop Speaking before System Checking.'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_CONSISTENSY
        = 'Link Type is Configured Uniformly, the Operation Will Not Take Effect'

    exports.INFO_CLOSE_BARRAGE_TIP = 'Use Whiteboard in the Barrage Area, Please Close the Barrage First'

    exports.INFO_SETTING_FORBID_BY_CLASS_STARTED = 'Cannot change this setting after the course starts'

    exports.INFO_RTMP_NOT_RUNNING = 'The teacher isn\'t pushing stream'

    exports.INFO_HAS_FORBID_MIC = 'Students\' microphone has been turn off'

    exports.INFO_HAS_BEEN_MUTED = 'Your microphone has been turn off'

    exports.INFO_MESSAGE_COPY_SUCCESS = 'Copy Success'

    exports.INFO_QA_COPY_SUCCESS = 'Copy Success'

    exports.INFO_QA_COPY_FAIL = 'Copy Fail'

    exports.INFO_PLAYER_PAUSE_BY_MIC_OFF = 'Please turn on your microphone to play this media file'

    exports.INFO_USER_ACTIVE_ADD_DENY
        = 'Server Reject Your Agreement, Because Audio And Video Concurrency Has Reached An Upper Limit。'

    exports.INFO_ENROLL_START = 'Start Enroll'

    exports.CLASSROOM_COUNTDOWN_TITLE = 'The live broadcast will start in'

    exports.INFO_GIFT_ANIMATION_ENABLE = 'Gift effects turned on'

    exports.INFO_GIFT_ANIMATION_DISABLE = 'Gift effect is turned off'

    exports.INFO_NO_CAMERA_OPERATION_PERMISSION = 'No camera operation permission'

    /**
     * =================================================
     * Empty INFO
     * =================================================
     */
    exports.INFO_NO_SPEAKER = 'No Speaker'

    /**
     * =================================================
     * Warning Reminders
     * =================================================
     */

    exports.WARNING_INPUT_FREQUENT = 'Don\'t Input Too Frequently.'

    exports.WARNING_INPUT_EMPTY = 'Please Type in Your Contents.'

    exports.WARNING_INPUT_OVERLENGTH = 'Please don\'t Type in Overlong Text.'

    exports.WARNING_CAMERA_SWITCH_FREQUENT = 'Please don\'t Turn Camera ON and OFF Too Frequently.'

    exports.WARNING_MIC_SWITCH_FREQUENT = 'Please don\'t Turn Mic ON and OFF Too Frequently.'

    exports.WARNING_CLOSE_DIALOG_ON_DOCUMENT_UPLOADING = 'Courseware Uploading. Please Wait.'

    exports.WARNING_SEND_MESSAGE_FORBID = 'You are not Allowed to Chat.'

    exports.WARNING_SURVEY_OPTION_HINT = 'Click Numbers and letters to Set Right Answer.'

    exports.WARNING_SURVEY_TEXTAREA_MAX = 'Maximum Character for Question is 200'

    exports.WARNING_SURVEY_OPTION_MAX = 'Maximum Character for Option is 25'

    exports.WARNING_VOLUME_OVERFLOW = 'Over Enlarging May Cause Distortion.'

    exports.WARNING_COMMENT_TEXT_HINT = 'Can Continue Typing'

    exports.WARNING_COMMENT_TEXT_UNIT = 'Character'

    exports.WARING_COMMENT_NO_TEXT = 'Please Type in Comment for Teacher.'

    exports.WARING_COMMENT_NO_CONTENT = 'Please Type in General Review for Teacher.'

    exports.WARING_COMMENT_UPLOAD_FULL = 'Upload Maximum 5 Pictures.'

    exports.WARNING_SWITCH_CDN_SERVER
        = 'Teacher Switching Route will Cause All Students to Reenter Classroom. Continue Switching?'

    exports.WARNING_ABROAD_CONFIRM = 'Confirm'

    exports.WARNING_ABRAOD_TIPS = 'Notice'

    exports.WARING_PLAY_FILE_FAILED = 'Play File Failed, File Type not Support'

    exports.WARING_PLAY_FILE_LENGTH_FAILED = 'Please upload audio/video files larger than 1s at least!'

    exports.WARN_WEBRTC_MEDIA_DEVICE_PERMISSON_DENY
        = '${authType} startup failed. Please allow us to access the ${deviceType}'

    exports.WARN_NO_AUTH_QUIZ = 'You are disabled for quiz permissions'

    exports.WARN_NO_AUTH_ANSWER = 'You have been disabled for answering machine permission'

    exports.RISK_ASSESSMENT = 'Risk assessment'

    /**
     * =================================================
     * Success Reminders
     * =================================================
     */

    exports.SUCCESS_UPLOAD_DOCUMENT = 'Upload Success. Trancoding Please Wait.'

    exports.SUCCESS_DETECT_CAMERA = 'Camera Device Detected.'

    exports.SUCCESS_DETECT_ASSIST_CAMERA = 'Auxiliary Camera Device Detected.'

    exports.FAIL_DETECT_ASSIST_CAMERA = 'Camera Device Undetected.'

    /**
     * =================================================
     * Error Reminders
     * =================================================
     */

    exports.ERROR_RECORD_FAIL_ON_PATH_NOT_EXIST = 'Not Existing. Cannot Continue Class Recording.'

    exports.ERROR_RECORD_FAIL_ON_DISK_NOT_ENOUGH = 'Not Enough Disc Space. Cannot Continue Class Recording.'

    exports.ERROR_UPLOAD_DOCUMENT = 'Uploading Failed'

    exports.ERROR_DOCUMENT_TYPE_NOT_SUPPORT = 'File Format Error. Please Upload word，ppt，pdf or Picture Format Files.'

    exports.ERROR_DOCUMENT_SIZE_NOT_SUPPORT = 'File Uploaded should be Less than 50M.'

    exports.ERROR_DOCUMENT_NAME = 'File Name includes Punctuation. Please Rename and Upload.'

    exports.ERROR_GET_GIFT_PAY_URL = 'Oops, Delivery Failed. Try Again...'

    exports.ERROR_RUN_CEF_FAIL = 'Client Initialization Failed. Please Restart Client.'

    exports.ERROR_NOT_SURPORT_SELL_TEMPLATE = 'Not Surport PC, Please Use Mobile'

    /**
     * =================================================
     * Invitation Letter
     * =================================================
     */

    exports.CLASSROOM_ENTER_COUNT_DOWN_LABEL = 'Broadcasting Count Down: '

    exports.ENTER_CLASSROOM_BY_JOIN_CODE = 'Enter Class with Join Code'

    exports.ENTER_CLASSROOM_WITH_SECRET = 'Enter Class with APP Secret Code'

    exports.JOIN_CODE = 'Join Code'

    exports.JOIN_CODE_SPECIFICATION = 'Join Code Instructions'

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_DAYS = 'Days'

    // 为了使倒计时的时间数字和量词之间不会挨在一起，要在‘时’和‘分’后加一个空格
    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_HOURS = 'Hours '

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_MINUTES = 'Minutes '

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_SECONDS = 'Seconds'

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_TITLE = 'Kind Reminder'

    exports.CLASS_START_TIME = 'Start Time'

    exports.TEACH_DURATION = 'Duration'

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_LABEL = 'Please Put in your Real Name: '

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_TIP = 'Text Cannot be Empty'

    exports.INVITATION_TITILE_HINT = 'Reminder'

    exports.INVITATION_TIP_OPENING_CLIENT = 'Trying to Open Client...'

    exports.INVITATION_BUTTON_DOWNLOAD_CLIENT = 'Download Client'

    exports.INVITATION_BUTTON_ENTER_CLASSROOM_VIA_WEB = 'Enter Class from Webpage'

    exports.INVITATION_LABEL_OTHER_METHOD_ENTER_CLASSROOM = 'Other Ways to Enter Classroom'

    exports.INVITATION_TIP_ADVICE_DOWNLOAD_CLIENT
        = 'If you have not Installed or cannot Open Client, Please Download Latest Client for Better Functions.'

    /**
     * =================================================
     * Countdown
     * =================================================
     */

    exports.CLASSROOM_ENTER_COUNT_DOWN_TIP = 'Can Enter Classroom ${preEnterTimeText} before Starting'

    exports.CLASS_EXPIRE_TIP = 'Oops...This Broadcasting has Ended.'

    exports.CLASS_DELETED_TIP = 'Oops...Instructor has Cancelled this Broadcasting'

    exports.CLASSROOM_ENTER_COUNT_DOWN_LABEL = 'Broadcasting Count Down: '

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_DAYS = 'Days'

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_HOURS = 'Hours'

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_MINUTES = 'Minutes'

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_SECONDS = 'Seconds'

    exports.CLASSROOM_ENTER_TIP_STRING_DAYS = 'Days'

    exports.CLASSROOM_ENTER_TIP_STRING_HOURS = 'Hours'

    exports.CLASSROOM_ENTER_TIP_STRING_MINUTES = 'Minutes'

    exports.CLASSROOM_ENTER_TIP_STRING_SECONDS = 'Seconds'

    exports.BUTTON_RETURN = 'Return'

    exports.BUTTON_ENTER = 'Enter the live room'

    /**
     * =================================================
     * Trial Class
     * =================================================
     */
    exports.TRIAL_START_TIP
        = 'Trial for ${leftMinutes} Minutes, and to View Full Broadcasting <span class="enroll">Enroll Now</span>'

    exports.TRIAL_END_TIP = 'Free Trial will End. If you like it <span class="enroll">Enroll Now</span>'

    exports.COURSE_ENROLL_HREF = 'Enroll Now'

    exports.FORBIDDEN_BTN_TIP = 'You Can Communicate with Teacher after Enrollment.'

    exports.TRIAL_LEAVE_NOTICE = 'Sure You Want to Leave Classroom?'

    /**
     * =================================================
     * Confirm
     * =================================================
     */

    exports.CONFIRM_END_CLASS = 'End the Class?'

    exports.CONFIRM_END_SPEAK = 'End Speaking?'

    exports.CONFIRM_END_WARMING_UP = 'End Warming Up?'

    exports.CONFIRM_STOP_RECORD = 'Stop Recording Class?'

    exports.CONFIRM_STOP_SCREEN_SHARE = 'Stop Sharing Desktop?'

    exports.CONFIRM_SWITCH_LINK_TYPE = 'Your network is not so stable, try to switch link type to solve?'

    exports.CONFIRM_STOP_SCREEN_SHARE_ON_CLOSE_CAMERA = 'Closing Camera will Stop Desktop Sharing. Still Close?'

    exports.CONFIRM_STOP_SCREEN_SHARE_ON_OPEN_CAMERA = 'Opening Camera will Stop Desktop Sharing. Still Open?'

    exports.CONFIRM_RELOAD_ON_WEBSOCKET_CLOSE_BJY = 'You Seem to be off Network. Check and Reconnect?'

    exports.CONFIRM_PUBLISH_VIDEO_BEFORE_SCREEN_SHARE = 'To Share Desktop Turn On Camera. Turn On Now?'

    exports.CONFIRM_PUBLISH_VIDEO_BEFORE_PLAY_MEDIA = 'To Play Local Media Turn On Camera. Turn On Now?'

    exports.CONFIRM_UPGRADE_BEFORE_USE = 'Current Client Verision Outdated. For Normal Viewing， Please Upgrade First.'

    exports.CONFIRM_UPGRADE_HINT
        = 'Current Client Verision Outdated. Click Update Button to Download Latest Version<br />For Better Experience.'

    exports.CONFIRM_EXIT_CLASSROOM = 'Whether to leave the live room?'

    exports.CONFIRM_EXIT_CLASSROOM_IN_CLASS = 'Leaving Classroom during Class will End Class. Confirm to Leave?'

    exports.CONFIRM_EXIT_CLASSROOM_IN_CLOUD_RECORD
        = 'While Class Recording, Leaving Classroom during Class will End Class and Stop Cloud Recording.'

    exports.CONFIRM_USE_CAMERA_ON_NO_AVAILABLE_CAMERA = 'No Available Camera Detected. Need to Use Camera?'

    exports.CONFIRM_USE_MIC_ON_NO_AVAILABLE_MIC = 'No Available Mic Detected. Need to Use Mic?'

    exports.CONFRIM_FORBID_USER_SEND_MESSAGE = 'Disallow Chatting?'

    exports.CONFIRM_REMOVE_DOCUMENT = 'Sure to Delete Class Courseware'

    exports.CONFIRM_REMOVE_HOMEWORK = 'Sure to Delete Class Homework'

    exports.CONFIRM_RELOAD_PLAYER_ON_NO_AVAILABLE_CAMERA = 'No Available Camera Device Detected. Recheck?'

    exports.CONFIRM_RELOAD_PLAYER_ON_NO_AVAILABLE_ASSIST_CAMERA
        = 'No Available Auxiliary Camera Device Detected. Recheck?'

    exports.CONFIRM_PURCHASE = 'Not Enrolled Yet. Enroll Now?'

    exports.CONFIRM_TO_TCP_LINK
        = 'Switching TCP uplink will cause student voice to be unable to record, confirm the switch？'

    exports.CONFIRM_END_RTMP_PUSH = 'Are you sure to stop the stream of teacher？'

    exports.CONFIRM_SCREEN_SHARE_BITRATE_CHANGE
        = 'The screen sharing rate in the live room has been changed, please click Re-share to take effect'

    exports.CONFIRM_CONNECT_HAND_WRITTING_BOARD_TITLE = 'Connect hand writing board'

    exports.CONFIRM_CONNECT_HAND_WRITTING_BOARD_CONTENT
        = 'Writepad connection failed, please reconnect<br>Please make sure the "hand writting board" is open and in communication range'

    exports.CONFIRM_BUTTON_CONNECT_HAND_WRITTING_BOARD = 'reconnect'

    exports.CONFIRM_PIP_ERR = 'During initialization, please click "OK" to take effect of the "show your face" function'

    exports.CONFIRM_TURN_OFF_ALL_USERS = 'Are you sure to turn off all users?'

    /**
     * =================================================
     * Tooltip
     * =================================================
     */

    exports.TOOLTIP_LASER = 'Laser Pointer'

    exports.TOOLTIP_MOVE = 'Move'

    exports.TOOLTIP_DOODLE = 'Paintbrush'

    exports.TOOLTIP_TEXT = 'Text'

    exports.TOOLTIP_ARROW = 'Arrow'

    exports.TOOLTIP_RECT = 'Rectangle'

    exports.TOOLTIP_ERASER = 'Erase'

    exports.TOOLTIP_CLEAR = 'Clear'

    exports.TOOLTIP_SMILE = 'Smile'

    exports.TOOLTIP_GIGGLE = 'Giggle'

    exports.TOOLTIP_PROUD = 'Proud'

    exports.TOOLTIP_NAUGHTY = 'Naughty'

    exports.TOOLTIP_EXHAUSTED = 'Exhausted'

    exports.TOOLTIP_CRY = 'Cry'

    exports.TOOLTIP_EMBARRASSED = 'Embarrassed'

    exports.TOOLTIP_DOUBT = 'Doubt'

    exports.TOOLTIP_APPEARANCE = 'Appearance'

    exports.TOOLTIP_POWERFUL = 'Powerful'

    exports.TOOLTIP_WORSHIP = 'Worship'

    exports.TOOLTIP_STRUGGLE = 'Struggle'

    exports.TOOLTIP_WEIGHS = 'Faint'

    exports.TOOLTIP_SURPRISE = 'Surprised'

    exports.TOOLTIP_SPEECHLESS = 'Speechless'

    exports.TOOLTIP_HEARTSTOPPER = 'Heartstopper'

    /**
     * =================================================
     * Dialog Box
     * =================================================
     */

    exports.DIALOG_MANAGE_DOCUMENT = 'Choose Courseware'

    exports.DIALOG_MANAGE_HOMEWORK = 'Homework'

    exports.DIALOG_DEBUG = 'Debugging Information'

    exports.USER_DIALOG_DEBUG = 'Class Information'

    exports.ALERT_DEFAULT_TITLE = 'Kind Reminder'

    exports.DIALOG_QUESTION_ANSWER = 'Question Answer'

    exports.DIALOG_DEBUG_PANEL = 'Debug Panel'

    exports.DIALOG_MESSAGE_BOX_PUBLIC = 'Chat-Public'

    exports.DIALOG_MESSAGE_BOX_RESEARCH = 'Chat-Research'

    exports.DIALOG_MESSAGE_BOX_WHISPER = 'Chat-Chatting with {user-name}'

    exports.DIALOG_USER_AUTH_TITLE = 'Tips'

    exports.MORE_BUTTON_TITLE = 'More Features'

    exports.MORE_BUTTON_TITLE_EDIT = 'Edit'

    exports.DIALOG_REPORT_TITLE = 'Please select the reason for reporting'

    /**
     * =================================================
     * Empty Text Placeholder
     * =================================================
     */

    exports.PLACEHOLDER_NOTICE_FOR_WRITER = 'Here is Announcement Board.'

    exports.PLACEHOLDER_NOTICE_GROUP_FOR_WRITER = 'Here is Notice Board.'

    exports.PLACEHOLDER_NOTICE_FOR_READER = 'Notice Board is Empty.'

    exports.PLACEHOLDER_INPUT_AMOUNT = 'Put in the Amount.'

    exports.PLACEHOLDER_COMMENT_FOR_SEND = 'Write a Comment to Teacher'

    /**
     * =================================================
     * Some Expressions
     * =================================================
     */

    exports.LABEL_RECORDING = 'Record'

    exports.LABEL_WECHAT_HELP = 'Wechat Help'

    exports.LABEL_STUDENT_JOIN_CLASS_NO = 'Student not in Classroom'

    exports.LABEL_STUDENT_JOIN_CLASS_YES = 'Student Entered Classroom'

    exports.LABEL_FAIL_AGAIN = 'Fail Again?'

    exports.LABEL_CONTACT_TEL = 'Call Customer Support: 4000-910-910'

    exports.LABEL_CONTACT_QQ = 'Or Add IT Support on QQ: 3303460898'

    exports.LABEL_CLASSROOM_ID_TEXT = 'Classroom ID'

    exports.LABEL_TOUCH_SCREEN_SUPPERT = 'Touch Screen Support'

    exports.LABEL_VIDEO_POPUP_TO_AUX_SCREEN = 'Video Pop up to Side Screen'

    exports.LABEL_REPAIR_PROGRAM_SHARE = 'Repair Black Screen of Program Share'

    exports.LABEL_MEDIA_PANEL = 'Users'

    exports.LABEL_MESSAGE_PANEL = 'Chat Room'

    exports.LABEL_LOADING = 'Loading...'

    exports.LABEL_DATA_LOADING = 'Loading Data. Please Wait...'

    exports.LABEL_VIDEO = 'Video'

    exports.LABEL_AUDIO = 'Audio'

    exports.LABEL_AUDIO_AND_VIDEO = 'Audio And Video'

    exports.LABEL_WHITEBOARD = 'Whiteboard'

    exports.LABEL_CAMERA = 'Camera'

    exports.LABEL_MIC = 'Mic'

    exports.LABEL_MIC_AND_CAMERA = 'Mic and Camera'

    exports.LABEL_SPEAKER = 'Speaker'

    exports.LABEL_RECORD = 'Class Recording'

    exports.LABEL_SHARE = 'Screen Sharing'

    exports.LABEL_CLASS_SETTING = 'Classroom Control'

    exports.LABEL_OTHER = 'Other'

    exports.LABEL_DEVICE_LIST = 'Devices'

    exports.LABEL_AUDIO_REPAIR = 'Repair'

    exports.LABEL_AUDIO_REPAIR_NO = 'No Need to Repair'

    exports.LABEL_AUDIO_REPAIR_LEFT = 'Repair Left Soundtrack'

    exports.LABEL_AUDIO_REPAIR_RIGHT = 'Repair Right Soundtrack'

    exports.LABEL_INPUT_VOLUME = 'Volume'

    exports.LABEL_OUTPUT_VOLUME = 'Volume'

    exports.LABEL_AGC = 'AGC'

    exports.LABEL_POPUP = 'Pop Up'

    exports.LABEL_CLOSE = 'Close'

    exports.LAEBL_CLOSE_MIC = 'Stop Speaking'

    exports.LABEL_PRIMARY_CAMERA_SETTING = 'Main Camera Settings'

    exports.LABEL_MINOR_CAMERA_SETTING = 'Auxiliary Camera Settings'

    exports.LABEL_NO_AVAILABLE_CAMERA = 'No Available Camera'

    exports.LABEL_NO_AVAILABLE_MIC = 'No Available Mic'

    exports.LABEL_NO_AVAILABLE_SPEAKER = 'No Available Speaker'

    exports.LABEL_VIDEO_QUALITY = 'Video Quality'

    exports.LABEL_CAN_YOU_HEAR_YOUR_VOICE = 'Notice: Please Speak. Can You Hear Your Own Voice?'

    exports.LABEL_APPLY_BEFORE_SPEAK = 'To Speak Please Raise Hand'

    exports.LABEL_WAIT_TEACHER_ACCEPT = 'Please Wait Until Teacher Accepts'

    exports.LABEL_SPEAK_APPLYING = 'Raising Hand'

    exports.LABEL_TEACHER_SPEAK_INVITING = 'Teacher Invites You to Speak'

    exports.LABEL_DOCUMENT_IN_LIBRARY = 'Librarys'

    exports.LABEL_DOCUMENT_IN_USE = 'Show Courseware'

    exports.LABEL_DOCUMENT_TYPE_HINT = 'WPS-Edited Files Please Transform to PDF Before Uploading.'

    exports.LABEL_DOCUMENT_HELP_LINK = 'Click Here to Check Transforming Instructions.'

    exports.LABEL_PAGE_LOADING = 'Courseware Loading...'

    exports.LABEL_DOCUMENT_TRANSFORMING = 'File Transforming. Please Wait...'

    exports.LABEL_DOCUMENT_TRANSFORMING_TIP = 'Transcoding...'

    exports.LABEL_DOCUMENT_TRANSFORM_COMPLETE_TIP = 'Transcoding Completed'

    exports.LABEL_DOCUMENT_TRANSFORM_FAIL = 'File Transforming Failed. Please Upload Again.'

    exports.LABEL_CLASS_DOCUMENT = 'Courseware'

    exports.lABEL_USER_DOCUMENT = 'Student Photo'

    exports.LABEL_UPLINK_BANDWIDTH = 'Uplink Bandwidth'

    exports.LABEL_DOWNLINK_BANDWIDTH = 'Downlink Bandwidth'

    exports.LABEL_FORBID_ALL_REMINDER = 'All Students Forbidden to Speak'

    exports.LABEL_SEND_GIFT_PAY_TITLE = 'Thank You Teacher'

    exports.LABEL_LOADING_TIMEOUT = 'Cannot Enter Class? Call 4000-910-910 for Help'

    exports.LABEL_SURVEY_QUESTION = 'Question: '

    exports.LABEL_SURVEY_MULTIPLE_ANSWER = 'Multiple Choice'

    exports.LABEL_SURVEY_SEND_TITLE = 'Ask Question'

    exports.LABEL_SURVEY_REPLY_TITLE = 'Answer Question'

    exports.LABEL_SURVEY_REPLY_RESULT = 'Reply Results'

    exports.LABEL_SURVEY_MYCHOICE = 'Your Choice'

    exports.LABEL_SURVEY_RIGHT_COUNT = 'Right Answer'

    exports.LABEL_SURVEY_WRONG_COUNT = 'Wrong Answer'

    exports.LABEL_SURVEY_OPTION_UNIT = 'People'

    exports.LABEL_SURVEY_TITLE_NAME = 'Answer Sheet'

    exports.LABEL_GIFT_TYPE_ORANGE_JUICE = 'Orange Juice'

    exports.LABEL_GIFT_TYPE_ICE_TEA = 'Iced Black Tea'

    exports.LABEL_GIFT_TYPE_BARLEY_TEA = 'Barley Tea'

    exports.LABEL_RECORDING_INDICATOR = 'Teacher Recording'

    exports.LABEL_RECORDING_LOCAL = 'Local'

    exports.LABEL_RECORDING_CLOUD = 'Cloud'

    exports.LABEL_RECORDING_PUSH = 'Push'

    exports.LABEL_RECORDING_SUFFIX = 'Recording'

    exports.LABEL_DOC_QUALITY_HIGH = 'HQ'

    exports.LABEL_DOC_QUALITY_LOW = 'LQ'

    exports.LABEL_DOC_FIT_WIDTH = 'Fill'

    exports.LABEL_DOC_FIT_VIEW = 'Adapt'

    exports.ALLOW_STUDENT_CHANGE_PPT = 'Allow：allow student change PPT'

    exports.FORBID_STUDENT_CHANGE_PPT = 'Forbid：Forbid student change PPT'

    exports.HIDDEN_REMARKINFO = 'Hidden：Hidden PPT remark'

    exports.SHOW_REMARKINFO = 'Show：show PPT remark'

    exports.LABEL_COMMENT_REMIND_TITLE = 'Review the Course'

    exports.LABEL_COMMENT_POINT_UNIT = 'Point'

    exports.LABEL_COMMENT_TEACHER_TITLE = 'My Reviews'

    exports.LABEL_COMMENT_TYPE_TOTAL = 'All'

    exports.LABEL_COMMENT_TYPE_GREAT = 'Good Review'

    exports.LABEL_COMMENT_TYPE_MIDDLE = 'Middle Review'

    exports.LABEL_COMMENT_TYPE_LOWER = 'Bad Review'

    exports.LABEL_COMMENT_MAX_LENGHT = '200 Characters'

    exports.LABEL_COMMENT_TOTAL_RATER = 'General Review'

    exports.LABEL_COMMENT_ANONYMOUS = 'Anonymous Review'

    exports.LABEL_COMMENT_REMARK = 'Remark'

    exports.LABEL_COMMENT_POINT_FIVE = '5 Star'

    exports.LABEL_COMMENT_POINT_FOUR = '4 Star'

    exports.LABEL_COMMENT_POINT_THREE = '3 Star'

    exports.LABEL_COMMENT_POINT_TWO = '2 Star'

    exports.LABEL_COMMENT_POINT_ONE = '1 Star'

    exports.LABEL_COMMENT_UNIT_TIPS = '${totalCount} Reviews in Total'

    exports.LABEL_COMMENT_TYPE = 'Learn to Comment'

    exports.LABEL_BEAUTIFY_AND_DENOISE = 'Beautify'

    exports.LABEL_SETTINGS = 'Settings'

    exports.LABEL_AUTH_MANAGEMENT = 'Auth Management'

    exports.LABEL_EYE_PROTECTION = 'Eye Protection'

    exports.LABEL_SCREENSHOT = 'Screenshot'

    exports.LABEL_SCREENSHOT_WITH_ROOM_HIDED = 'screenshot with client hided'

    exports.LABEL_POSITION = 'Position ${number}'

    exports.LABEL_DETECT_TOOL = 'System Detection'

    exports.LABEL_FORBID_ALL = 'Forbid All'

    exports.LABEL_SHARE_POSITION = 'Screen Sharing Image Position'

    exports.LABEL_SHARE_POSITION_MOD_TIP = 'Modifiable in Settings'

    exports.LABEL_NUMBER_ONE = '1'

    exports.LABEL_NUMBER_TWO = '2'

    exports.LABEL_NUMBER_THREE = '3'

    exports.LABEL_NUMBER_FOUR = '4'

    exports.LABEL_NUMBER_FIVE = '5'

    exports.LABEL_NUMBER_SIX = '6'

    exports.LABEL_NUMBER_SEVEN = '7'

    exports.LABEL_NUMBER_EIGHT = '8'

    exports.LABEL_NUMBER_NINE = '9'

    exports.LABEL_NUMBER_TEN = '10'

    exports.LABEL_SERVER_ROUTE = 'Route ${number}'

    exports.LABEL_OTHER_SERVER_ROUTE = 'Other Route'

    exports.LABEL_CDN_ROUTE_PRIMARY = 'P'

    exports.LABEL_CDN_ROUTE_ASSISTANT = 'A'

    exports.LABEL_CHECK_ALL = 'Choose All'

    exports.LABEL_UNIT = 'Unit'

    exports.LABEL_LINK_TYPE = 'Link Type'

    exports.LABEL_UPLINK = 'Uplink'

    exports.LABEL_DOWNLINK = 'Downlink'

    exports.LABEL_TCP = 'TCP'

    exports.LABEL_UDP = 'UDP'

    exports.LABEL_TEACHER = 'Teacher'

    exports.LABEL_NICKNAME = 'Nickname'

    exports.LABEL_DON_NOT_REMIND_ANY_MORE = 'Do not Remind Any More'

    exports.LABEL_GIFT_PAY_HINT = 'Payment Method'

    exports.LABEL_GIFT_WECHAT = 'Wechat'

    exports.LABEL_GIFT_ALIPAY = 'Alipay'

    exports.LABEL_COMMENT_RECEIVE_TITLE = 'Review List'

    exports.LABEL_COMMENT_SEND_TITLE = 'Review This Course'

    exports.LABEL_LOTTERY_SEND_TITLE = 'Present Gift'

    exports.LABEL_LOTTERY_SEND_HEADER = '"Tell Students What Surprise This Time"'

    exports.LABEL_LOTTERY_SEND_NAME = 'Lottery Name'

    exports.LABEL_LOTTERY_SEND_NUMBER = 'Gift Quantity'

    exports.LABEL_CURRENT_STUDENT_COUNT = '${userCount} Students in Current Classroom'

    exports.LABEL_LOTTERY_SEND_HINT
        = 'Lottery Winning Students Can Get Gift Code<br/>To Present Lottery, Teachers Need to Contact Students.'

    exports.LABEL_LOTTERY_DRAW_HINT = 'Teachers will Present Gifts with Gift COde'

    exports.LABEL_LOTTERY_SEND_BTN = 'Present Gifts'

    exports.LABEL_LOTTERY_UNIT = 'Unit'

    exports.LABEL_LOTTERY_REMAIN = 'Remaining'

    exports.LABEL_LOTTERY_SAVE_LIST = 'Save List'

    exports.LABEL_LOTTERY_DRAW_TIP = 'Send a Gift'

    exports.LANEL_LOTTERY_DRAW_BTN = 'Draw'

    exports.LABEL_LOTTERY_DRAW_SUCC = 'Congratulations! You Won the Lottery.'

    exports.LABEL_LOTTERY_DRAW_CODE = 'Gift CodeS'

    exports.LABEL_LOTTERY_SHOW_WINNERS = 'See Winners'

    exports.LABEL_LOTTERY_DRAW_FAIL = 'Out of Red Envelop'

    exports.LABEL_LOTTERY_REDPACK = 'Red Envelop'

    exports.LABEL_OF_UNITE = 'of'

    exports.LABEL_INPUT_LOTTERY_NAME = 'Input Lottery Name'

    exports.LABEL_INPUT_LOTTERY_NUMBER_ERROR = 'Input Correct Number of Lotteries'

    exports.LABEL_INPUT_LOTTERY_OVER_MEMBER = 'Lottery Number Cannot be Larger than Student Number'

    exports.LABEL_INPUT_LOTTERY_OVER_MAX = 'Lottery Number Cannot be over 50'

    exports.LABEL_CAMERA_PIXEL_RATIO = 'Pixel Ratio'

    exports.LABEL_CAMERA_SETTING = 'Pixel Setting'

    exports.LABEL_CAMERA_FLIP_HORIZONTAL = 'Flip Horizontal'

    exports.LABEL_CAMERA_FLIP_VERTICAL = 'Flip Vertical'

    exports.LABEL_CAMERA_CROP = 'Picture Crop'

    exports.LABEL_CAMERA_DISENABLE = 'Disenable'

    exports.LABEL_TIP_CLICK_BTN_START_CLASS = 'Click Button to Start Class'

    exports.LABEL_UPDATE_OLD_CLIENT_VERSION
        = 'The current client version is too low, please upgrade to the latest version'

    exports.LABEL_UPDATE_CLIENT_VERSION = 'Proceed to Download Latest Client'

    exports.LABEL_CLOSE_CLIENT = 'Close Client'

    exports.LABEL_CLIENT_INVITE_CODE = 'Client Invitation Code'

    exports.LABEL_WEB_LINK = 'Webpage Link'

    exports.LABEL_REFRESH_WAITED = 'Refreshing. Please Wait.'

    exports.LABEL_SHAREING_NO_OPTION = 'Screen is sharing, do not support this operation.'

    exports.LABEL_WHISPER_TITLE = 'Private Chat'

    exports.LABEL_BARRAGE = 'Barrage'

    exports.LABEL_LOCK_SCREEN = 'Screen Lock'

    exports.LABEL_RAISE_HAND = 'Raise Hand'

    exports.LABEL_APPLY_SPEAK = 'Request To Speak'

    exports.LABEL_SAVE_SUCCESS = 'Save Success！'

    /**
     * =================================================
     * Help
     * =================================================
     */

    exports.BUTTON_CUSTOM_SERVICE_QQ = 'QQ'

    exports.BUTTON_CUSTOM_SERVICE_TECHNICAL = 'Tech'

    exports.BUTTON_CUSTOM_SERVICE_CLASS_INFO = 'Class info'

    exports.BUTTON_CUSTOM_SERVICE_WECHAT = 'WeChat'

    exports.BUTTON_CUSTOM_SERVICE_OFFICIAL = 'Official'

    exports.DIALOG_TITLE_TECH_HELP = 'Technical assistance'

    exports.TITLE_HELP_TYPE = 'Reason for Help'

    exports.TITLE_CONTACT_WAY = 'Contact'

    exports.TYPE_VIDEO_LAG = 'Video Lag'

    exports.TYPE_CLIENT_CRASH = 'Client Crash'

    exports.TYPE_OTHER = 'Other'

    exports.CONTACT_TYPE_QQ = 'QQ'

    exports.CONTACT_TYPE_PHONE = 'Mobile'

    exports.PLACEHOLDER_DESCRIPTION = 'Describes your problem'

    exports.INFO_CREATE_HELP_SUCCESS = 'Your problem has been sent to the relevant teacher who will contact you later!'

    exports.UNKNOW_ERROR = 'Unknown error occurred'

    exports.WARING_INVALID_PHONE = 'Invalid mobile number'

    exports.WARING_INVALID_QQ = 'Invalid QQ number'

    exports.WARING_DESCRIPTION_EMPTY = 'The description can not be empty'

    exports.SUBMIT_HELP_TOO_FREQUENT = 'Please do not submit it too often...'

    /**
     * =================================================
     * Expressions about Audio and Video Players
     * =================================================
     */

    exports.MEDIA_PLAYER_KEEP_ON = 'Please Keep Video Device ON'

    exports.MEDIA_PLAYER_FILE_LOADING = 'Loading ${fileName}'

    exports.MEDIA_PLAYER_CLOSE_VIDEO = 'Camera ON. Click to Close Other Side\'s Image.'

    exports.MEDIA_PLAYER_OPEN_VIDEO = 'Camera ON. Click to Open Other Side\'s Image.'

    exports.MEIDA_PLAYER_CAMERA_OFF = 'Other Side\'s Camera OFF'

    exports.MEDIA_PLAYER_MIC_ON = 'Mic ON'

    exports.MEDIA_PLAYER_MIC_OFF = 'Mic OFF'

    exports.MEDIA_PLAYER_CLOSE_MIC = '，Click to Close Other Side\'s Mic'

    exports.MEDIA_PLAYER_POPUP = 'Click to Pop up Window'

    exports.MEDIA_PLAYER_SWITCH = 'Click to Switch PPT and Video Windows'

    exports.MEDIA_PLAYER_VIDEO_DOWNLINK_BANDWIDTH = 'Receive Video: '

    exports.MEDIA_PLAYER_AUDIO_DOWNLINK_BANDWIDTH = 'Receive Audio: '

    exports.MEDIA_PLAYER_VIDEO_UPLINK_BANDWIDTH = 'Uplink Video: '

    exports.MEDIA_PLAYER_AUDIO_UPLINK_BANDWIDTH = 'Uplink Audio: '

    exports.MEDIA_PLAYER_FOLD = 'Fold'

    exports.MEDIA_PLAYER_UNFOLD = 'Unfold'

    /**
     * =================================================
     * CEF Related Expressions
     * =================================================
     */

    exports.CEF_ERROR_PLAYBACK_AUDIO = 'Audio Device Error'

    exports.CEF_ERROR_SYSTEM_NOT_SUPPORT = 'Your OS does not Support this Function. Please Change PC or Upgrade OS.'

    exports.CEF_ERROR_CAMERA_IS_BUSY = 'Your Camera May be Occupied by Other Program. Please Check.'

    exports.CEF_ERROR_OPEN_MIC = 'Mic Failed to Open. Please Restart Live Broadcasting Assistant.'

    exports.ALERT_CREATE_STREAM_TIMEOUT = 'Timeout for get audio and video stream.please check the camera device and refresh page try again.'

    exports.CEF_ERROR_WORK_MIC = 'Mic Can Not Work Properly. Please Check.'

    exports.CEF_ERROR_OPEN_SPEAKER = 'Speaker Failed to Open. Please Restart Live Broadcasting Assistant.'

    exports.CEF_ERROR_CAPTURE_AUDIO = 'Mic Failed to Collect Data. Please Restart Live Broadcasting Assistant.'

    /**
     * =================================================
     * Expressions Needing Variable Replacements
     * =================================================
     */

    exports.TPL_LOGIN_CONFLICT
        = 'Your Account/Invite Code Just Logged in at other deviced/terminals. Please confirm and log in again!'

    exports.TPL_STUDENT_SEND_TEACHER_GIFT = '<em>${userName}</em> Sent Teacher a Gift'

    exports.TPL_TEACHER_RECEIVE_STUDENT_GIFT = 'Received a Gift from <em>${userName}</em>'

    exports.TPL_TEACHER_FORBID_USER_SEND_MESSAGE = '<em>${userName}</em> is Forbidden to Speak by Teacher'

    exports.TPL_CUSTOM_SERVICE_CALL = 'Click to Confirm, Call IT Support<br />Pick up Call at <em>  ${mobile} </em>'

    exports.TPL_DETECT_TOOL_NET_STATUS_SPEED = '<em>${netStatusMsg}</em>，Delay${speed}ms'

    exports.TIME_NOCTICE_JOIN_CLASS = 'Will Reenter Class after ${seconds}s'

    /**
     * =================================================
     * Login and Register
     * =================================================
     */

    exports.LOGIN_REGISTER_LOGIN = 'Login'

    exports.LOGIN_REGISTER_REGISTER = 'Register'

    exports.LOGIN_REGISTER_LOGIN_WAITING = 'Logging In...'

    exports.LOGIN_REGISTER_REGISTER_WAITING = 'Registering...'

    exports.LOGIN_REGISTER_MOBILE = 'Please Enter Cellphone Number'

    exports.LOGIN_REGISTER_SET_PASSWORD = 'Please Set Password'

    exports.LOGIN_REGISTER_INPUT_PASSWORD = 'Please Enter Password'

    exports.LOGIN_REGISTER_INPUT_VERIFYCODE = 'Please Enter Cellphone Verification Code'

    exports.LOGIN_REGISTER_SEND_VERIFYCODE = 'Get Verification Code'

    exports.LOGIN_REGISTER_SEND_VERIFYCODE_COUNTING = 'Seconds Later Retry'

    exports.LOGIN_REGISTER_MOBILE_ERROR = 'Please Input Correct Cellphone Number.'

    exports.LOGIN_REGISTER_PASSWORD_ERROR = 'Please Input Correct Password.'

    exports.LOGIN_REGISTER_CAPTCHA_ERROR = 'Please Input Correct CAPTCHA.'

    exports.LOGIN_REGISTER_VERIFYCODE_ERROR = 'Please Input Correct Verification Code.'

    exports.LOGIN_REGISTER_DIALOG_TITLE = 'Confirm Login'

    exports.LOGIN_REGISTER_LOGIN_BY_SMS = 'Login by SMS'

    exports.LOGIN_REGISTER_LOGIN_BY_PASSWORD = 'Login by Password'

    exports.LOGIN_REGISTER_INPUT_CAPTCHA = 'Input Text Below'

    exports.LOGIN_REGISTER_SWITCH_ROLE = 'You are Not Registered as Student. Register as Student?'

    /**
     * =================================================
     * Emergency Call（Customer Service Call）
     * =================================================
     */

    exports.CUSTOM_SERVICE_NEED_CALL = 'Any Problem? Free Call for Help！'

    exports.CUSTOM_SERVICE_CONFIRM_CALL = 'Confirm Call'

    exports.CUSTOM_SERVICE_REJECT_CALL = 'No Cellphone'

    exports.CUSTOM_SERVICE_EXTRA_FEE
        = '（Some Users May be Charged by Mobile Carriers for Answering Calls or Roaming.）'

    exports.CUSTOM_SERVICE_CALLING = 'Calling out for Help'

    exports.CUSTOM_SERVICE_PICKUP
        = 'Please Connect Call from <em>010-86448910</em> <br />and Wait for Technology Support.'

    exports.CUSTOM_SERVICE_DAIL = 'Dial Directly for Help.'

    exports.CUSTOM_SERVICE_DAIL_CONTENT
        = 'You Can Call Technology Support Directly<br />and Wait for Service. <br /><em>4000910910</em>'

    exports.CUSTOM_SERVICE_AUTO_CLOSE = 'Window Automatically Closing...'

    exports.CUSTOM_SERVICE_DIALOG_TITLE = 'Ask Customer Service for Help.'

    exports.CUSTOM_SERVICE_QQ_MESSAGE = 'Ask Technology Support to Solve Problem via QQ.'

    exports.CUSTOM_SERVICE_QQ_SYSTEM_INFO = 'System: {system}, Version: {system-version}'

    exports.CUSTOM_SERVICE_QQ_BROWSER_INFO = 'End: {browser}, Version: {browser-version}'

    exports.CUSTOM_SERVICE_QQ_PRIMARY = 'Technology Support 1'

    exports.CUSTOM_SERVICE_QQ_SECONDARY = 'Technology Support 2'

    /**
     * =================================================
     * Device Change
     * =================================================
     */

    exports.DEVICE_CHANGE_ADD_AUDIO = 'Current Mic Switched to Newly Inserted Device'

    exports.DEVICE_CHANGE_ADD_VIDEO = 'Current Camera Switched to Newly Inserted Device'

    exports.DEVICE_CHANGE_DEL_AUDIO = 'Mic Device Pulled out. Switched to Default Device.'

    exports.DEVICE_CHANGE_DEL_VIDEO = 'Camer Device Pulled out. Switched to Default Device.'

    exports.DEVICE_CHANGE_RESET = 'Express Settings'

    /**
     * =================================================
     * Sign In
     * =================================================
     */

    exports.SIGNIN_TITLE_HINT = 'Roll Call'

    exports.SIGNIN_START = 'Start Roll Call'

    exports.SIGNIN_STATUS = 'Sign in Status'

    exports.SIGNIN_TIME_NOTICE = 'Please Set Students Should Respond within ${seconds} Seconds.'

    exports.SIGNIN_ACK_COUNT = '${member} Signed in'

    exports.SIGNIN_NACK_COUNT = '${member} not Signed in'

    exports.SIGNIN_EXPECT_COUNT = 'expect ${member}'

    exports.SIGNIN_LIST_DOWNLOAD = 'Full List Download'

    exports.GROUP_SIGNIN_LIST_DOWNLOAD = 'Group List Download'

    exports.SIGNIN_NO_LIST = 'List of People not Signed ins'

    exports.SINGIN_NO_NOTICE = 'System Displays 50 People not Signed in. To View Full List Please Click'

    exports.SIGNIN_AGAIN = 'Roll Call Again'

    exports.SIGNIN_AGAIN_TIME_NOTICE = 'Can Restart Roll Call after ${seconds} Seconds'

    exports.SINGIN_WAIT_TIME_NOTICE = 'Students Signing in. Check Result ${seconds} Later. Please Wait.'

    exports.SIGNIN_REPLAY = 'Reply'

    exports.SIGNIN_REPLAY_TIME_NOTICE = 'Teacher Asks You to Reply to Roll Call Within ${seconds} Seconds'

    exports.SIGNIN_RESULT_GETTING = 'Generating Roll Call Result'

    exports.SIGNIN_COMPLETE_NOTICE = 'Sign in Statistics Generated'

    exports.SIGNIN_GETTING_RESULT = 'Check Result'

    /**
     * =================================================
     * Sign In List
     * =================================================
     */

    exports.JOIN_USERLIST_TITLE_HINT = 'Remind'

    exports.JOIN_USERLIST_TITLE_LIST = 'Sign in List'

    exports.JOIN_USERLIST_HINT
        = 'Sign in List will Record Student\'s Nicknames, Earliest Arrival Time, Latest Leaving Time.<br /> List does not Include Guests or Students Who Remained in Classroom for Too Short time.<br /> List Generating may Cause Random Pauses.<em>Usage After Class Suggested</em>.'

    exports.JOIN_USERLIST_COPY_HINT = 'Sign in List Generated. You can export as a CSV file'

    exports.LABEL_CONFIRM = 'Confirm'

    exports.JOIN_USERLIST_CLOSE = 'Close'

    exports.JOIN_USERLIST_FETCH = 'Generate List'

    exports.JOIN_USERLIST_FETCHING = 'Generate...'

    exports.JOIN_USERLIST_STUDENT_ID = 'Student ID'

    exports.JOIN_USERLIST_STUDENT_NAME = 'Student Nickname'

    exports.JOIN_USERLIST_LOGIN_TIME = 'Earliest Arrival Time'

    exports.JOIN_USERLIST_LOGOUT_TIME = 'Latest Leaving Time'

    exports.JOIN_USERLIST_GROUP = 'Group ID'

    exports.JOIN_USERLIST_ENDTYPE = 'End Type'

    exports.JOIN_USERLIST_COPY = 'Export'

    exports.JOIN_USERLIST_STILL_IN = 'Not Left'

    exports.JOIN_USERLIST_NOBODY_HINT = 'No Sign in Student at the Moment'

    /**
     * =================================================
     * TA Link
     * =================================================
     */

    exports.ASSISTANT_LINK = 'TA Link'

    exports.ASSISTANT_LINK_NEW_HINT
        = '[Latest Updates] TA Can Now Use <em>Client</em> to Login & Record & Play Video！ （Entrance: Client Login Page Right Bottom Corner）'

    exports.ASSISTANT_LINK_HINT
        = 'Copy and Send TA List to Friend So He/She Can Enter Classroom as TA <br /> and Owns Rights to Manage Student Speaking, Record Class and So On.'

    exports.ASSISTANT_LINK_LABEL_NAME = 'TA Name: '

    exports.ASSISTANT_LINK_LABEL_AVATAR = 'Choose Portrait: '

    exports.ASSISTANT_LINK_DEFAULT_NAME = 'TA'

    exports.ASSISTANT_LINK_NAME_MAXLENGTH = 'TA Cannot Exceed 8 Characters'

    exports.ASSISTANT_LINK_NAME_EMPTY = 'Put in TA Name'

    exports.ASSISTANT_LINK_SUCCESS = 'TA Link Generation Success. Please Keep it Secret！'

    exports.ASSISTANT_LINK_COPY_SUCCESS = 'Link Copy Success'

    exports.ASSISTANT_LINK_FAILURE = 'TA Link Error'

    /**
     * =================================================
     * Courseware Zooming Toolbars
     * =================================================
     */

    exports.DOC_QUALITY_LOW = 'Low Quality: Use Compressed Courseware. Page Turning Fast.'

    exports.DOC_QUALITY_HIGH = 'High Quality: Picture Clear, but <em>Random Pauses May Occur</em>.'

    exports.DOC_FIT_VIEW = 'Adapt: No Scroll Bar. Image Relatively Small.'

    exports.DOC_FIT_WIDTH = 'Fill: Allow Scroll Bar. Image Relatively Big.'

    /**
     * =================================================
     * System Detection Tools
     * =================================================
     */

    exports.DETECT_TOOL_DIALOG_TITLE = 'System Detection'

    exports.DETECT_TOOL_CUSTOM_SERVICE = 'Ask Technology Support for Help'

    exports.DETECT_TOOL_TIPS = 'Suggested Solution: '

    exports.DETECT_TOOL_NET_STATUS_LEGEND_GOOD = 'Good - Smooth Class'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_OK = 'Normal - Occasional Random Pauses'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_NORMAL = 'Bad - Frequent Random Pauses'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_BAD = 'Very Bad - Cannot Proceed'

    exports.DETECT_TOOL_NET_STATUS_GOOD = 'Network Good'

    exports.DETECT_TOOL_NET_STATUS_OK = 'Network Normal'

    exports.DETECT_TOOL_NET_STATUS_POOR = 'Network Poor'

    exports.DETECT_TOOL_NET_STATUS_TERRIBLE = 'Network Terrible'

    exports.DETECT_TOOL_NET_STATUS_DETECT = 'Network Connection CheckW'

    exports.DETECT_TOOL_NET_STATUS_DETECTING = 'Checking Network......'

    exports.DETECT_TOOL_NET_STATUS_TIPS_HEADER = 'If Network is poor, Please Try Methods Below: '

    exports.DETECT_TOOL_NET_STATUS_TIPS_CLOSE_P2P = 'Close Thunder and Other P2P Software. Use Cable to Connect PC.'

    exports.DETECT_TOOL_NET_STATUS_TIPS_CHECK_LAN = 'Check If Other Users in LAN are Occupying Large Bandwidth'

    exports.DETECT_TOOL_NET_STATUS_TIPS_REBOOT = 'Restart PC and Router'

    exports.DETECT_TOOL_NET_STATUS_NO_RESULT
        = 'Not Acquired Velocity Information or Network Disconnected. Please Check Again.'

    exports.DETECT_TOOL_HELP_NET = 'FAQ about Network'

    exports.DETECT_REFRESH_NOTICE = 'Unable to Connect Classroom? Switch Network and Try Refreshing.'

    exports.DETECT_NET_PROGRAM_REFRESH_NOTICE = 'Network error. Please check your network settings and try to refresh.'

    exports.DETECT_TOOL_REDETECT = 'Re-detect'

    exports.DETECT_TOOL_SPEAKER_DETECT = 'Speaker Detection'

    exports.DETECT_TOOL_SPEAKER_INITIATING = 'Initiating Speaker......'

    exports.DETECT_TOOL_SPEAKER_TEST_SOUND_PLAYING = 'Testing Music Playing......'

    exports.DETECT_TOOL_SPEAKER_HAVE_YOU_HEARD = 'Can You Hear Test Sound?'

    exports.DETECT_TOOL_SPEAKER_NO_DEVICE = 'Speaker Device not Detected'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHECK_PLUG = 'Check If Speaker Connection is Normal and ON.'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_DEVICE = 'Switch Speaker Device'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_VOLUME = 'Adjust Speaker Volume'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_VOLUME_OUTER = 'Adjust Outlay Speaker Volume Button'

    exports.DETECT_TOOL_SPEAKER_TIPS_OS_SETTING
        = 'Open <span class="os-setting-trigger">Speaker Settings</span>, See If Speaker is Disabled.'

    exports.DETECT_TOOL_SPEAKER_TIPS_SETTING_MAC
        = 'Open <em>System Preference Settings->Sound->Output</em>,Check Speaker Settings.'

    exports.DETECT_TOOL_SPEAKER_TIPS_SETTING_WINDOWS
        = 'Open<em>Start->Control Panel->Sound->Play</em>, See If Speaker is Disabled.'

    exports.DETECT_TOOL_HELP_SPEAKER = 'FAQ about Speaker'

    exports.DETECT_TOOL_MIC_DETECT = 'Mic Detection'

    exports.DETECT_TOOL_MIC_DETECTING = 'Speak to Mic'

    exports.DETECT_TOOL_MIC_DETECTING_TIPS = 'Wear Earphone and Close Speaker Amplifying Function to Avoid Echo'

    exports.DETECT_TOOL_MIC_HAS_INPUT = 'Sound Input Detected'

    exports.DETECT_TOOL_MIC_HAS_INPUT_WARNING
        = 'Strongly Suggest Closing Amplifying Function and Wearing Earphone to Avoid Noise and Echo.'

    exports.DETECT_TOOL_MIC_NO_INPUT = 'No Sound Input Detected'

    exports.DETECT_TOOL_MIC_NO_DEVICE = 'No Mic Device Detected'

    exports.DETECT_TOOL_MIC_TIPS_HEADER = 'If Any Problem, Try Methods Below: '

    exports.DETECT_TOOL_MIC_TIPS_CHANGE_VOLUME = 'Adjust Mic Volume'

    exports.DETECT_TOOL_MIC_TIPS_CHANGE_DEVICE = 'Switch Mic Device'

    exports.DETECT_TOOL_MIC_TIPS_HEADER_UNDETECTED = 'Please Try Methods Below: '

    exports.DETECT_TOOL_MIC_TIPS_CHECK_PLUG = 'Check if Mic Connection Normal and ON'

    exports.DETECT_TOOL_MIC_TIPS_CHECK_BLOCK = 'Check if Browser or Firewall Intercepted Device Usage'

    exports.DETECT_TOOL_MIC_TIPS_OS_SETTING
        = 'Open <span class="os-setting-trigger">Mic Settings </span>, Check if Mic is Disabled.'

    exports.DETECT_TOOL_MIC_TIPS_SETTING_MAC
        = 'Open <em> System Preference Settings->Sound->Input</em>, Check Mic Settings.'

    exports.DETECT_TOOL_MIC_TIPS_SETTING_WINDOWS
        = 'Open <em>Start->Control Panel->Sound->Recording</em>, Check if Mic is Disabled.'

    exports.DETECT_TOOL_HELP_MIC = 'FAQ about Mic'

    exports.DETECT_TOOL_CAMERA_DETECT = 'Camera Detection'

    exports.DETECT_TOOL_CAMERA_HAS_CAMERA = 'Can You See Image?'

    exports.DETECT_TOOL_CAMERA_NO_CAMERA = 'No Camera Device Detected'

    exports.DETECT_TOOL_CAMERA_TIPS_HEADER = 'If No Image Showing, Please Try Mothods Below:'

    exports.DETECT_TOOL_CAMERA_TIPS_CHECK_PLUG = 'Check If Camera Connection Normal'

    exports.DETECT_TOOL_CAMERA_TIPS_CHECK_CLOSE_OTHER = 'Please Try Closing Other Programs that May Occupy Camera'

    exports.DETECT_TOOL_CAMERA_TIPS_CHANGE_DEVICE = 'Switch Camera Devices'

    exports.DETECT_TOOL_CAMERA_TIPS_OS_SETTING = 'Camera Settings'

    exports.DETECT_TOOL_CAMERA_TIPS_SETTING_MAC
        = 'In <em> Apple->About the Device->Preview->System Report->In Camera/USB</em> Check If Camera Device Installed Normal'

    exports.DETECT_TOOL_CAMERA_TIPS_SETTING_WINDOWS
        = 'In <em> Start->Control Panel->Device Manager</em> Check If Camera Device Installed Normal'

    exports.DETECT_TOOL_HELP_CAMERA = 'FAQ about Camera'

    exports.DETECT_TOOL_FINISH = 'System Detection Completed'

    exports.DETECT_TOOL_FINISH_TIPS
        = 'If System Problem Still Exist, Try Restarting Live Broadcasting Assistant, PC and Router, or Contact Technology Support for Assistance.'

    /**
     * =================================================
     * settings
     * =================================================
     */

    exports.SETTINGS_MIC_PREFERENCE_SCALING = 'Mic Enhancement'

    exports.SETTINGS_MIC_PREFERENCE_SCALING_UNIT = 'db'

    exports.SETTINGS_TIP_DETECT_CLOSE = 'Detecting Device Will Close ${services}. Continue?'

    exports.SETTINGS_INFO_TIP_OPEN_CAMERA = 'If Video Needed, Click to Open Camera'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_CAMERA_FORBIDDEN
        = 'This Course is Audio Live Broadcasting Course. Cannot Use Camera.'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_SCREEN_SHARE_FORBIDDEN
        = 'This Course is Audio Live Broadcasting Course. Cannot Use Screen Sharing Function.'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_MEDIA_PLAY_FOBIDDEN
        = 'This Course is Audio Live Broadcasting Course. Cannot Play Video.'

    /**
     * =================================================
     * Reminders after Media Player Switch
     * =================================================
     */

    exports.SWITCH_TIP_CLOSE_CAMERA
        = 'We Detected Large Network Fluctuation and High Packet Loss. Try Closing Video to Reduce Student-End Random Pausing.'

    exports.SWITCH_TIP_SWITCH_CDN
        = 'We Detected Large Network Fluctuation and High Packet Loss. Try Lowering Video Definition to Reduce Random Pausing.'

    exports.SWITCH_TIP_NET_STATUS
        = 'We Detected Large Network Fluctuation and High Packet Loss. Please Check Network Status.'

    exports.SWITCH_TIP_TEACHER_NET_STATUS
        = 'Large Fluctuation at Teacher-End Network. Occasional Random Pausing May Occur.'

    /**
     * =================================================
     * Class ation Related Bottom Operations
     * =================================================
     */
    exports.CLASS_ACTION_TIP_DOWNLOAD_WINDOWS
        = 'Only Client Supports Raising Hand and Speaking.'
        + 'Click<a href="http://www.baijiayun.com/default/home/liveclientDownload?type=windows" target="_blank">Here</a>to Download'

    exports.CLASS_ACTION_TIP_DOWNLOAD_MAC
        = 'Only Client Supports Raising Hand and Speaking.'
        + 'Click<a href="http://www.baijiayun.com/default/home/liveclientDownload?type=mac" target="_blank">Here</a>to Download'

    exports.CLASS_ACTION_TIP_DOWNLOAD
        = 'Only Client Supports Raising Hand and Speaking.'
        + 'Click<a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">Here</a>to Downloads'

    /**
     * =================================================
     * Reminders when Entering Classroom
     * =================================================
     */

    exports.ENTER_CLASSROOM_MASTER_SERVER_CONNECTING = 'Connecting Main Server'

    exports.ENTER_CLASSROOM_MASTER_SERVER_CONNECT_SUCCESS = 'Main Server Connection Success'

    exports.ENTER_CLASSROOM_SERVER_INFO_FETCH_SUCCESS = 'Server Information Acquisition Success'

    exports.ENTER_CLASSROOM_ROOM_SERVER_CONNECT_SUCCESS = 'Classroom Server Connection Success'

    exports.ENTER_CLASSROOM_ROOM_SERVER_LOGIN_SUCCESS = 'Classroom Server Login Success'

    exports.ENTER_CLASSROOM_AUTH_TOKEN_FAIL = 'Invalid User'

    exports.ENTER_CLASSROOM_OVERMAN = 'The Classroom is Full. Please Try Later.'

    exports.ROOM_SERVER_LOGIN_CONFLICT_CONFIRM
        = 'The room already has a lecturer. Entering will cause the lecturer to leave the classroom. Do you want to continue to enter?'

    /**
     * =================================================
     * Expressions Helping New Users
     * =================================================
     */

    exports.USER_GUIDE_DOWNLOAD_TEACHER
        = 'Teach More Smoothly and Experience Better Functions with Client.'
        + 'Don\'t Hesitate. Click <a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">Here</a>to Download'

    exports.USER_GUIDE_DOWNLOAD_STUDENT
        = 'Teach More Smoothly and Experience Better Functions with Client. Don\'t Hesitate.'
        + 'Click<a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">Here</a>to Download'

    /**
     * =================================================
     * Server Reconnection Reminders
     * =================================================
     */

    exports.RECONNECT_ROOM_SERVER_WAITING = 'The network is weak, please check the network...'

    exports.RECONNECT_ROOM_SERVER_SUB_WAITING = 'Trying to reconnect'

    exports.ROOM_SERVER_LOGIN_EXPIRED_TIP = 'Class expired'

    /**
     * =================================================
     * Course Recording
     * =================================================
     */

    exports.RECORD_CLASS_REMIND = 'Recording Interrupted. Please Click to Restart Recording.'

    exports.RECORD_INFO_TIP = 'We Suggest Recording Class and Upload Playback after Class.'

    exports.RECORD_COMPLETE_TIP = 'Class Recording Completed.<span class="btn-action">Open Local Recording File.</span>'

    exports.RECORD_STOPPING_TIP = 'Generating local recording file, please wait...'

    exports.RECORD_RESTART_TIP
        = 'Local Recording Stopped. Please<span class="btn-action"> Open </span>Local Recording Again.'

    /**
     * =================================================
     * Automatic Recording
     * =================================================
     */

    exports.AUTO_RECORD_START = 'Class Recording will Automatically Start.'

    exports.AUTO_RECORD_RESTART = 'Class Recording will Automatically Restart.'

    exports.AUTO_RECORD_STOP = 'Class Recording Stops. Can Upload in Client for Students to Playback.'

    exports.AUTO_RECORD_CLASS_COUNT_DOWN_TIP = 'Seconds Later To'
    exports.AUTO_RECORD_CANCEL = 'Cancel'
    exports.AUTO_RECORD_LATER = 'Remind Later'

    exports.AUTO_RECORD_MODE_CLOUD_AND_LOCAL = ' Cloud+Local '

    exports.AUTO_RECORD_MODE_CLOUD = 'Cloud'

    exports.AUTO_RECORD_MODE_LOCAL = 'Local'

    exports.AUTO_RECORD_REASON = 'The class was set to enable cloud recording at start automatically.'

    exports.AUTO_RECORD_TIP_NET_DISK_EMPTY
        = 'Storage Space Full. Unable to do Cloud Recording. Please Manually Start Recording After Expansion.'

    exports.NO_RECORD_WHEN_AUTO_RECORD
        = 'The system detects that it does not open the cloud recording, and whether it opens the cloud recording.'

    /**
     * =================================================
     * Environment Detection
     * =================================================
     */
    exports.ENV_DETECT_HEADER = 'Accelerate Network'

    exports.ENV_DETECT_ACTION = 'Accelerating Button'

    exports.ENV_DETECT_KILLING = 'Optimizing'

    exports.ENV_DETECT_KILL_COMPLETE = 'Optimization Success'

    exports.ENV_DETECT_PROCESS = 'Programs Suggested to Close'

    /**
     * =================================================
     * CDN Supplier Name
     * =================================================
     */

    exports.CDN_DNION = 'Dnion'

    exports.CDN_NET_CENTER = 'ChinaNetCenter'

    exports.CDN_CHINA_CACHE = 'ChinaCache'

    /**
     * =================================================
     * Recording
     * =================================================
     */

    exports.RECORD_COLLECTS_LOCAL_RECORD = 'Local Recording'

    exports.RECORD_COLLECTS_CLOUD_RECORD = 'Cloud Recording'

    exports.RECORD_COLLECTS_ALL_RECORD = 'Local+Cloud Recording'

    exports.RECORD_COLLECTS_CLOUD_RECORD_LIST = 'Manage Cloud Playback'

    exports.RECORD_COLLECTS_PRE_START_INFO = 'Start Class Recording'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME = 'Class has Ended. Only Local Recording Allowed.'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME_WEB = 'Class has Ended.Cloud Recording not Allowed.'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME_PAUSE
        = 'Class has Ended for Over 15 minutes. Cloud Recording will End after Pause. Sure to End?'

    exports.RECORD_COLLECTS_CLOUD_RECORD_PAUSING_OVER_TIME
        = 'Not Recovered Recording within 15 minutes after Class. Cloud Recording will End. Teachers Please Notice.'

    exports.CLOUD_RECORD_OVER_TIME_WARNING_INFO_BTN = 'I Got it'

    exports.END_RECORD_COLLECTS_PAUSE_RECORD = 'Pause'

    exports.END_RECORD_COLLECTS_STOP_RECORD = 'Stop'

    exports.END_RECORD_THEN = 'Do not Generate Now'

    exports.END_RECORD_START_PLAYBACK = 'Generate Playback Now'

    exports.ALERT_STOP_PUSH_RECORD = 'Are you sure stop push record?'

    /**
     * =================================================
     * Recording Settings
     * =================================================
     */

    exports.RECORD_SETTINGS_TITLE = 'Recording Settings'

    exports.RECORD_SETTINGS_AUTO_START = 'Automatically Open after Starting Class'

    exports.RECORD_SETTINGS_AUTO_START_LOCAL = 'Local Recording'

    exports.RECORD_SETTINGS_AUTO_START_CLOUD = 'Cloud Recording'

    exports.RECORD_SETTINGS_RECORD_MODE = 'Class Recording Mode'

    exports.RECORD_SETTINGS_RECORD_MODE_PART = 'Window Recording'

    exports.RECORD_SETTINGS_RECORD_MODE_FULLSCREEN = 'Full-screen Recording'

    exports.RECORD_SETTINGS_PATH = 'Save Class Videos to'

    // exports.RECORD_SETTINGS_REMEMBER = 'Remember Choice（Modifiable at “More-Class Recording Settings”）';

    exports.RECORD_SETTINGS_LOCATION_TIP = 'Modifiable at “More-Recording Settings”'

    /**
     * =================================================
     * Cloud Recording
     * =================================================
     */

    exports.CLOUD_RECORD_CONFIRM_START
        = 'Start Cloud Recording and Generate Class Playback after Class?<br />（Currently Cloud Recording while Class not Supported.）'

    exports.CLOUD_RECORD_START_TIP_SDK
        = 'Cloud Recording Records Class at Cloud Server.（<strong style="color:red;">Do not Record Student.<br />'
        + 'Or TA Speaking Audio and Video</strong>）,Recorded Class not Saved Locally<br />'
        + 'File, Generate Class Playback 10 Minutes after Class.<br />'

    exports.PUSH_RECORD_START_TIP_SDK
        = 'The screenshot push recording needs to keep the client open all the time and keep the fullscreen. <br />'
        + 'The recording file is not saved locally, and the course playback will be <br /> '
        + 'automatically generated 10 minutes after the course ends<br />'
        + 'info: <br />'
        + '    1. Do not turn off the speaker at the recording end, otherwise no sound can be recorded; <br />'
        + '    2. Do not move the client out of the recording window, otherwise the removed part of the recording will display a black screen; '

    exports.ALERT_PUSH_RECORD_NETWORK_ERROR
        = 'As the network may be disconnected<br />please check the network and try again'

    exports.CLOUD_RECORD_OVERTIME_STOP_TIP = 'Over 8 Hours after Class. Cloud Recording Automatically Stopped.'

    exports.CLOUD_RECORD_PRE_START_TIP = 'Start Cloud Recording, and Generate Playback afer Class.'

    exports.CLOUD_RECORD_OVERTIME_TIP = 'Class Ended. Cannot Start Cloud Recording.'

    exports.CLOUD_RECORD_RESTART_TIP
        = 'If you Need to Pause Recording During Class, Click to Pause, and Reclick Recording When Needed.'

    exports.CLOUD_RECORD_WITHOUT_TEACHER_WARNING = 'While teacher is not present, cloud recording is not allowed.'

    /**
     * =================================================
     * Roll Call
     * =================================================
     */
    exports.SIGININ_SUCCESS = 'Sign in Success'

    /**
     * =================================================
     * Disc Space
     * =================================================
     */

    exports.NET_DISK_INFO_TITLE = 'Notice'

    exports.NET_DISK_INFO_BTN = 'I Got It'

    exports.NET_DISK_INFO_POOR_PREFFIX = 'Your Cloud Storage Space Remaining'

    exports.NET_DISK_INFO_POOR_SUFFIX
        = 'MB，Not Able to Upload Courseware When Space is Full. Please<a target="_blank" href="/teacher_center/storage_space"> Purchase </a>More Cloud Storage Space or <a target="_blank" href="/teacher_center/netdisk">Clear</a> Useless Flies.'

    exports.NET_DISK_INFO_POOR_WRITE_PREFFIX = 'Your Cloud Storage Space is Only Remaining'

    exports.NET_DISK_INFO_POOR_WRITE_SUFFIX = 'MB, Running out of Cloud Space. Unable to do Cloud Recording.'

    exports.NET_DISK_INFO_EMPTY
        = 'Your Cloud Storage Space is not Enough. Unable to Upload Courseware at the Moment. Please Immediately <a target="_blank" href="/teacher_center/storage_space"> Purchase</a> More Cloud Storage Space or<a target="_blank" href="/teacher_center/netdisk"> Clear</a> Useless Files.'

    exports.NET_DISK_INFO_EMPTY_WRITE_PREFFIX = 'Your Cloud Storage Space has exceeded'

    exports.NET_DISK_INFO_EMPTY_WRITE_SUFFIX = 'MB, Running out of Cloud Space. Unable to do Cloud Recording.'

    exports.NET_DISK_INFO_EXCEED_WRITE_PREFFIX = 'Your Cloud Storage Space has exceeded'

    exports.NET_DISK_INFO_EXCEED_WRITE_SUFFIX = 'MB, Run out of Cloud Space. Unable to do Cloud Recording.'

    /**
     * =================================================
     * More Options Button of User List
     * =================================================
     */

    exports.MORE_SETTINGS_BUTTON_FORBID_SEND_MESSAGE = 'Forbid Speaking'

    exports.MORE_SETTINGS_BUTTON_UNFORBID_SEND_MESSAGE = 'Allow Speaking'

    /**
     * =================================================
     * Third-Party Push Service
     * =================================================
     */

    exports.SERVICE_OF_THIRD_PUSH_STREAM_TITLE = 'Third-party Push Service'

    exports.LABEL_URI_OF_THIRD_PUSH_STREAM = 'RTMP Push Address: '
    exports.LABLE_SERVER_STATUS_NORMAL = 'Push Service Normal'
    exports.LABLE_TRANSPOND_AUDIO_STREAM = 'Transpond Audio Data'
    exports.LABLE_SERVER_STATUS_ABNORMAL = 'Push Service Abnormal'
    exports.LABLE_SERVER_STATUS_PREPARING = 'Server Preparing...'

    exports.BUTTON_REFRESH_LIST = 'Refresh List'
    exports.BUTTON_COPY_URI_OF_SERVER = 'Copy'
    exports.BUTTON_RESTART_SERVER = 'Restart Service'
    exports.BUTTON_START_TRANPONDING_STREAM = 'Start Transponding'
    exports.BUTTON_STOP_TRANPONDING_STREAM = 'Stop Transponding'

    exports.STREAM_INFO_ITEM_FIELD_STREAM_NAME = 'Stream Name'
    exports.STREAM_INFO_ITEM_FIELD_VIDEO_ENCODER = 'Video Code'
    exports.STREAM_INFO_ITEM_FIELD_RESOLUTION = 'Video Resolution'
    exports.STREAM_INFO_ITEM_FIELD_AUDIO_ENCODER = 'Audio Code'
    exports.STREAM_INFO_ITEM_FIELD_SAMPLE_RATE = 'Audio Sample'
    exports.STREAM_INFO_ITEM_FIELD_STATUS = 'Status'

    exports.STREAM_INFO_STATUS_STREAM_BROKEN = 'No Data'
    exports.STREAM_INFO_STATUS_IS_TRANSPONDING = 'Transponding'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_SUPPORTED = 'Not Supported'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_TRANSPONDING = 'Not Transponded'

    exports.RESTART_SERVER_FAILED_TIP = 'Restart Service Failed'
    exports.COPY_SUCCESS_TIP = 'Copy Success'
    exports.PUSH_STREAM_FAILED_TIP = 'Transponding Failed'
    exports.CAN_NOT_GET_SERVER_URL_TIP = 'Unable to Acquire Server Address'

    exports.STREAM_INFO_MARK_IS_TRANSPONDING = 'Transpond'

    exports.INFO_NO_DATA_FROM_STREAM = 'No Third-party Stream. Please Check Device and Network or Restart Service.'

    /**
     * =================================================
     * Double Camera Switching
     * =================================================
     */
    exports.WHITEBOARD_NAME = 'Whiteboard/Courseware'
    exports.ASSIST_CAMERA = 'Auxiliary Camera'
    exports.SCREEN_SHARE = 'Sreen Sharing'

    exports.CLOSE_MEDIA_BEFORE_DETECT = 'Please Stop Audio and Video File First.'
    exports.CLOSE_DESKTOP_SHARE_BEFORE_DETECT = 'Please Close Screen Sharing First.'

    exports.SETTING_CAMERA_DISABLE = 'Camera in Use. Unable to Modify Settings at the Moment.'
    exports.SETTING_ASSIST_CAMERA_DISABLE = 'Auxiliary Camera in Use. Unable to Modify Settings at the Moment.'
    exports.SETTING_SHARE_DISABLE = 'Desktop Sharing in Use. Unable to Modify Settings at the Moment.'

    exports.MORE_SETTINGS_BUTTON_INVITE_SPEAK_INIT = 'Invite to Speak'

    exports.MORE_SETTINGS_BUTTON_INVITE_SPEAK_INVITING = 'Cancel Invitation'

    exports.MORE_SETTINGS_MARK_INVITING = 'Inviting'

    exports.MORE_SETTINGS_MARK_SPEAKING = 'Speaking'

    exports.MORE_SETTINGS_BUTTON_OPEN_SPEAK_INIT = 'Open Speaking Function'

    exports.MORE_SETTINGS_BUTTON_OPEN_SPEAK_OPENING = 'Opening'

    exports.MORE_SETTINGS_BUTTON_SPEAK_INVITE_UNSUPPORTED_HOVER_TIP
        = 'This User is Using Webpage Version. Speaking Invitation not Supported.'

    /**
     * =================================================
     *
     * Third-party Push Service
     * =================================================
     */

    exports.SERVICE_OF_THIRD_PUSH_STREAM_TITLE = 'Third-party Push Service'

    exports.LABEL_URI_OF_THIRD_PUSH_STREAM = 'RTMP Push Address: '
    exports.LABLE_SERVER_STATUS_NORMAL = 'Push Service Normal'
    exports.LABLE_TRANSPOND_AUDIO_STREAM = 'Transpond Audio Data'
    exports.LABLE_SERVER_STATUS_ABNORMAL = 'Push Service Abnormal'

    exports.BUTTON_COPY_URI_OF_SERVER = 'Copy'
    exports.BUTTON_RESTART_SERVER = 'Restart Service'
    exports.BUTTON_START_TRANPONDING_STREAM = 'Start Transponding'
    exports.BUTTON_STOP_TRANPONDING_STREAM = 'Stop Transponding'

    exports.STREAM_INFO_ITEM_FIELD_STREAM_NAME = 'Stream Name'
    exports.STREAM_INFO_ITEM_FIELD_VIDEO_ENCODER = 'Video Code'
    exports.STREAM_INFO_ITEM_FIELD_RESOLUTION = 'Video Resolution'
    exports.STREAM_INFO_ITEM_FIELD_AUDIO_ENCODER = 'Audio Code'
    exports.STREAM_INFO_ITEM_FIELD_SAMPLE_RATE = 'Audio Sample'
    exports.STREAM_INFO_ITEM_FIELD_STATUS = 'Status'

    exports.STREAM_INFO_STATUS_STREAM_BROKEN = 'No Data'
    exports.STREAM_INFO_STATUS_IS_TRANSPONDING = 'Transponding'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_SUPPORTED = 'Not Supported'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_TRANSPONDING = 'Not Transponded'

    exports.RESTART_SERVER_FAILED_TIP = 'Restart Service Failed'
    exports.COPY_SUCCESS_TIP = 'Copy Success'
    exports.PUSH_STREAM_FAILED_TIP = 'Transponding Failed'
    exports.CAN_NOT_GET_SERVER_URL_TIP = 'Unable to Acquire Server Address'
    exports.STREAM_INFO_MARK_IS_TRANSPONDING = 'Transpond'
    /**
     * =================================================
     * Double Camera Switching
     * =================================================
     */
    exports.WHITEBOARD_NAME = 'Whiteboard/Courseware'
    exports.ASSIST_CAMERA = 'Auxiliary Camera'
    exports.SCREEN_SHARE = 'Sreen Sharing'

    exports.SIGNIN_FORBID = 'Next Roll Call should be at Least 1 Minute after Previous Roll Call.'

    /**
     * =================================================
     * Roll Call
     * =================================================
     */
    exports.SIGNIN_FORBID = 'Next Roll Call should be at Least 1 Minute after Previous Roll Call.'

    exports.BEGIN_EXAM_TIP = 'Start Exam?'

    exports.END_EXAM_TIP = 'End Exam?'

    exports.BEGIN_EXAM_INFO = 'Exam Started'

    exports.END_EXAM_INFO = 'Exam Ended'

    exports.UNKNOW_EMOTION = '[Unknown Emotion]'

    /**
     * =================================================
     * Browser Upgrade Reminder
     * =================================================
     */
    exports.UPGRADE_CLOSE_POWER_SAVING_MODE = 'Close Power Save Mode'

    exports.UPGRADE_NOTICE_SAFARI
        = 'You are Using Safari Browser. Please be Sure to Close Power Save Mode to Ensure Audio and Video Normal.'

    exports.UPGRADE_SAFARI_SETTING = 'Safari Settings-Advanced'

    exports.UPGRADE_CANCEL_CHECK = 'Untick'

    exports.UPGRADE_NOTICE_NO_FLASH
        = 'System Detected Your Flash is not Working Normally. Classroom Functions will not Work Well.<br /> Please Try to Click Video Below. If cannot Play, Use after Downloading.'

    exports.UPGRADE_BROWSER_GOOGLE = 'Google Browser'

    exports.UPGRADE_FAIL_CONTACT_TEL = 'If Problem not Solved, Please Contact Customer Service 4000-910-910。'

    exports.UPGRADE_CLOSE_POWER_SAVING_MODE_CHROME
        = 'You are Using the Latest Chrome Browser. Please Close Power Save Mode to Ensure Audio and Video Normal.'

    exports.UPGRADE_CHROME_SETTING_STEP_ONE = 'Go to Chrome Plug-in Unit Settings Page.'

    exports.UPGRADE_CHROME_SETTING_STEP_TWO = 'Tick Always Allow Adobe Flash Player'

    exports.UPGRADE_REFRESH_LIVE_ROOM = 'Refresh Live Broadcasting Classroom Page'

    exports.UPGRADE_NO_FLASH_CAN_NOT_START
        = 'Your Browser did not Install flash Plug-in. Classroom Functions will not Work Well'

    exports.UPGRADE_INSTALL_GUIDE = 'Installment Instructions'

    exports.UPGRADE_TAKE_A_LOOK = 'Take a Look'

    exports.UPGRADE_NOTICE_TO_LOW_BROWSER
        = 'Your Browser does not Support Advanced Functions of Online Classroom. Advanced Browser Recommemded.'

    exports.UPGRADE_ENABLE_NEW_TECH = 'Immediately Start Newest Technology.'

    exports.UPGRADE_BY_REJECT = 'Just Use it'

    exports.FLASH_CAN_NOT_USE
        = 'The web page Flash plugin is not loaded successfully. You can try the following actions'

    exports.CLICK_ALLOW_TIP = 'And choose "allow" on the prompt.'

    exports.CLICK_INSTALL_TIP = 'And install'

    exports.CLICK_TIP = 'Click'

    exports.ALLOW_FLASH = 'Enable Flash'

    exports.DOWNLOAD_FLASH = 'Download Flash'

    /**
     * =================================================
     * Manage Courseware
     * =================================================
     */

    exports.DOCUMENT_UPLOAD = 'Upload'

    exports.DOCUMENT_UPLOAD_ING = 'Uploading'

    exports.DOCUMENT_UPLOAD_FROM_NETDISK = 'Uploading from Library'

    exports.DOCUMENT_HAS_ADD = 'Courseware Added'

    exports.DOCUMENT_SUPPORT_FORMAT = 'Support ppt、pptx、doc、docx、jpg、png、pdf'

    exports.DOCUMENT_MOVE_UP = 'Move Up'

    exports.DOCUMENT_MOVE_DOWN = 'Move Down'

    exports.DOCUMENT_UPLOAD_STAUS_CACEL = 'Uploading Cancel'

    exports.DOCUMENT_UPLOAD_STAUS_ING = 'Uploading'

    exports.DOCUMENT_UPLOAD_STAUS_FAIL = 'Uploading Failed'

    exports.DOCUMENT_TRANSFORM_STATUS_FAIL = 'Transcoding Failed'

    exports.DOCUMENT_TRANSFORM_STATUS_WAIT = 'Waiting to Transcode'

    exports.DOCUMENT_TRANSFORM_ING = 'Transcoding'

    exports.DOCUMENT_HAS_ADD_STATUS = 'Added'

    exports.DOCUMENT_TRANSFORM_NOTICE = 'WPS-Edited Documents should be Transformed to PDF before Uploading.'

    exports.DOCUMENT_DEMO_LINK = 'Click Here to See Transforming Instructions.'

    exports.DOCUMENT_CAN_USE_STATUS = 'Not in Use'

    exports.DOCUMENT_HAS_BE_CHECKED = 'Checked'

    exports.DOCUMENT_UPLOAD_ING_NOTICE = 'File Uploading. Please Wait...'

    exports.DOCUMENT_MANAGEMENT = 'Courseware Management'

    exports.DOCUMENT_BACK_TO_MANAGEMENT = 'Return to Courseware Management'

    exports.SURVEY_PLEASE_INPUT_ANSWER = 'Please input answer'

    exports.PLACEHOLDER_NOITCE_CONTENT = 'Input the Announcement content'

    exports.PLACEHOLDER_NOITCE_LINK = 'Input the Announcement link (option)'

    exports.PLACEHOLDER_NOITCE_GROUP_CONTENT = 'Input the notice content'

    exports.PLACEHOLDER_NOITCE_GROUP_LINK = 'Input the notice link (option)'

    exports.KICK_OUT = 'Remove from class'

    exports.ENTER_CLASSROOM_KICKED_OUT = 'You are not allowed to join the class again'

    exports.KICKED_OUT_BY_ROOM_DISABLED_TIP
        = 'The current live room has been disabled and you have been invited out of the room.'

    exports.ALERT_KICK_OUT_AFTER_CLASS_30_MINUTES = 'The course has ended, welcome to continue watching next time'

    exports.KICKED_OUT_TIP = 'You have been removed from the class'

    exports.KICKED_OUT_BY_AUDITION_END_TIP
        = 'Your audition time is up. If you want to continue attending the class, please sign up and participate！'

    exports.CLASS_END_TIP = 'Live is over~'

    exports.CLASS_ENDED = 'The class should have been over'

    exports.TIME_BEFORE_CLASS_END = 'The class is expected to be over in ${time} seconds'

    exports.CLASS_HAS_BEGAN_TIME = 'Class time: ${hours} hours ${minutes} minutes ${seconds} seconds'

    exports.WARNING_APPLY_SPEAK_STATUS_SWITCH_FREQUENT = 'Please Don\'t Toggle Speaking Status Too Frequently'

    /**
     * =================================================
     * 设置主讲人
     * =================================================
     */

    exports.YOU_ARE_PRESENTER = '您被设置为主讲'

    exports.YOU_ARE_NOT_PRESENTER = '您被收回主讲权限'

    exports.SET_USER_PRESENTER_TIP = '主讲已经切到${username}'

    exports.CANCEL_USER_PRESENTER_TIP = '已收回用户${username}的主讲权限'

    exports.CANCEL_USER_PRESENTER_WHEN_OUT_TIP = '用户${username}退出教室,已被收回的主讲权限'

    exports.OPEN_CAMERA_FAIL_TIP = '打开摄像头失败'

    exports.OPEN_MIC_FAIL_TIP = '打开麦克风失败'

    exports.PRESENTER_IN = '主讲已进入教室'

    exports.PRESENTER_OUT = '主讲已离开教室'

    exports.BJY_SUPPORT = 'baijiayun provide live streaming services'

    exports.CONFIRM_SEND_PRIZE = '是否发送红包？'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_CPU = '检测到电脑CPU使用率过高，为保证正常直播，请关闭与直播无关的软件'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_MEMORY = '检测到电脑内存使用率过高，为保证正常直播，请关闭与直播无关的软件'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_BOTH
        = '检测到电脑CPU和内存使用率过高，为保证正常直播，请关闭与直播无关的软件'

    exports.NETWORK_BAD_WARNING = 'Network is poor. The video might be stuck.'

    exports.CHANGE_LINK_TYPE_DUE_TO_NETWORK = 'Network is too poor, trying to switch other links.'

    exports.LABEL_WHITEBOARD_FILL = 'Fill'

    exports.LABEL_WHITEBOARD_STROKE = 'Stroke'

    exports.LABEL_FORBID_RAISE_HAND = 'Forbid Raise Hand'

    exports.INFO_FORBID_RAISE_HAND = 'Forbid raise hand'

    exports.INFO_UNFORBID_RAISE_HAND = 'Allow raise hand'

    exports.INFO_FORBID_OPEN_MIC = 'Forbid Turn On Mic'

    exports.INFO_UNFORBID_OPEN_MIC = 'Allow Turn On Mic'

    exports.INFO_TEACHER_FORBID_RAISE_HAND = 'raise hand has forbidden by teacher'

    exports.LABEL_GUEST = 'User'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_NEW = 'Continue previous cloud record or start a new one?'

    exports.INFO_BUTTON_CONTINUE = 'Continue Record'

    exports.INFO_BUTTON_START_NEW = 'New Record'

    exports.LABEL_GUEST = 'User'

    exports.SELECT_PROGRAM = 'Select program to share'

    exports.CONFIRM_REMOVE_DOCUMENT_TRANSFORM_ING = 'The document is being transcode, Sure you want to delete it?'

    exports.BUTTON_UPLOAD_PPT_DOCUMENT = 'Upload PPT'

    exports.BUTTON_CHROME_FLASH_USER_GUIDE1_COMPLETE = 'Complete'

    exports.PRE_STEP = 'Prev Step'

    exports.NEXT_STEP = 'Next Step'

    exports.TIP_CHROME_FLASH_MORE_SETTING = 'The problem is still not solved？'

    exports.VIEW_MORE_SETTING = 'See more related settings'

    exports.LABEL_NO_LONGER_REMIND = 'Not remind again'

    exports.BUTTON_CLOSE = 'Close'

    exports.CHROME_UPGRADE_INSTRUCTION = '您的浏览器中的Flash Player存在异常，请按以下方法正确设置后才能直播'

    exports.CHROME_TIP_FLASH_SETTING_SET = '1.将下图蓝色框标识区域设置为'

    exports.CHROME_TIP_FLASH_SETTING_ALLOW = '在此网站上始终允许'

    exports.CHROME_TIP_FLASH_SETTING_THEN = '，然后'

    exports.CHROME_TIP_FLASH_SETTING_REFRESH = '刷新'

    exports.CHROME_TIP_FLASH_SETTING_BROWSER = '浏览器'

    exports.CHROME_TIP_FLASH_DOWNLOAD = '2.若设置后仍显示该页面，则需要下载安装最新的Flash Player'

    exports.DOWNLOAD_FLASH = 'Download'

    exports.CHROME_MORE_SETTING_FLASH = '查看更多相关设置'

    /**
     * apple 帮助信息
     */
    exports.APPLE_HELP_INFO = '致电8610-85255961或发邮件至yandong.liu@apple.com'

    exports.TIP_DO_NOT_SUPPORT_LOW_VERSION_IE = '呜~您的浏览器版本太低了~我们已经不支持IE9以下的版本了！'

    exports.TIP_LOW_VERSION_IE_UPDATE_BROWSER = '1、请升级浏览器'

    exports.TIP_LOW_VERSION_IE_DOWNLOAD_CHROME = '立即下载'

    exports.TIP_LOW_VERSION_IE_CHANGE_MODE = '2、若您使用的是360、QQ、搜狗等浏览器，请切换到极速模式'

    exports.TIP_LOW_VERSION_IE_CHANGE_BROWSER = '3、更换其他浏览器'

    exports.TIP_LOW_VERSION_IE_CLASS_TYPE_LIVE = '云端直播'

    exports.TIP_LOW_VERSION_IE_CLASS_TYPE_CLASSROOM = '云端课堂'

    exports.TIP_INVITATION_NAME_INPUT = '请输入您的昵称：'

    exports.TIP_INVITATION_NAME_INPUT_MOBILE = '请输入您的手机号：'

    exports.TIP_INVITATION_NAME_INPUT_MOBILE_WRONG = '请输入正确的手机号'

    exports.PLACEHOLDER_INVITATION_JOINCODE_INPUT = '您可以向您的直播管理者索要参加码'

    exports.TIP_INVITATION_GET_JOINCODE = '请输入您的参加码：'

    exports.TIP_INVITATION_NAME_SHOULD_NOT_BE_EMPTY = '昵称不能为空'

    exports.TIP_INVITATION_MOBILE_SHOULD_NOT_BE_EMPTY = '手机号不能为空'

    exports.TIP_INVITATION_JOINCODE_SHOULD_NOT_BE_EMPTY = '参加码不能为空'

    exports.TIP_INVITATION_JOINCODE_IS_NOT_RIGHT = '请输入正确的参加码'

    exports.LOCAL_RECORD_PATH_NULL = 'Please select the local storage video path'

    exports.INFO_LOCK_SCREEN = 'Locked'

    exports.INFO_LOCK_SCREEN_STUDENT
        = 'The teacher has turned on the student lock. You can\'t operate any other software at the moment'

    exports.INFO_UNLOCK_SCREEN = 'Unlocked'

    exports.LABEL_NERVER_PRINT = 'Don\'t show again'

    exports.LABEL_LOCK_SCREEN_OPEN = 'Open'

    exports.INFO_LOCK_SCREEN_FIRST
        = 'After opening the student lock, the students who use Windows client can only use the live software.'

    exports.INFO_COLLECT_SYSTEM_SOUND_FIRST
        = 'After opening the system sound collecting, you can turn down the volume or mute the speaker to avoid the echo.'

    exports.MEDIA_PLAYER_LOAD_FILE_FAILED = 'File load failed, please make sure the file can play or open other file'

    exports.CLASS_SWITCH_PARENT_TIP = 'Checkout Child'

    exports.CLASS_SWITCH_CHILD_TIP = 'Checkout Parent'

    exports.PARENT_CLASS_SWITCH_PARENT_TIP = 'Checkout Child'

    exports.PARENT_CLASS_SWITCH_CHILD_TIP = 'Checkout Parent'

    exports.CLASS_SWITCH_PARENT_SUCCESS_TIP = 'Switch Parent Class Success'

    exports.CLASS_SWITCH_CHILD_SUCCESS_TIP = 'Switch Child Class Success'

    exports.CLASS_SWITCH_ROOM_SERVER_WAITING = 'Switching, reconnecting the server…'

    exports.CLASS_SWITCH_TIP = 'Are you sure to switch the class?'

    exports.CLASS_SWITCH_TIP_CLOUD_RECORD = '<div class="confirm-class-switch-tip">Cloud record will be paused</div>'

    exports.CLASS_SWITCH_MEDIA_PLAYER_TIP = 'Please stop the mediaPlayer'

    exports.CLASS_SWITCH_THIRD_PUSH_TIP = 'Please stop the thirdPush'

    exports.CLASS_SWITCH_SCREEN_SHAR_TIP = 'Please stop the screen sharing'

    exports.CLASS_SWITCH_VIDEO_LAYOUT_TIP = 'Please stop the video layout'

    exports.CLASS_SWITCH_EXAM_TIP = 'Please stop the exam'

    /**
     * 图片添加至文档
     */
    exports.LABEL_IMAGE = 'Image'

    exports.LABEL_IMAGE_VIEW = 'Image Preview'

    exports.LABEL_IMAGE_DOWNLOAD = 'Download'

    exports.LABEL_ADD_TO_DOCUMENT = 'Add'

    exports.LABEL_OPEN_ON_BLACKBOARD = 'Add+Open'

    exports.INFO_IMAGE_ADD_SUCCESS = 'Add to File Success'

    exports.INFO_IMAGE_ADD_FAIL = 'Add to File Fail'

    exports.WARING_IMAGE_HAS_ADDED = 'Image is Already Added'

    exports.QRCODE_IMAGE_UPLOAD_DONE = 'Upload success, automatically close after ${countDown} second(s)'

    /**
     * 问答提示
     */
    exports.INFO_QUESTION_ANSWERED = 'Your question has been answered, check it~'

    exports.CONFIRM_CLOSE_QUSETION_ANSWER = 'Content is not sent, are you sure to exit？'

    /**
     * 浏览器不兼容提示
     */
    exports.BROWSER_NOT_SUPPORT_TIP_IE = 'Your browser version is too low, please upgrade to IE10 or above.'

    exports.BROWSER_NOT_SUPPORT_TIP_WECHAT = 'There is no support for WeChat\'s built-in browser.'

    exports.BROWSER_NOT_SUPPORT_TIP_WEBRTC
        = 'Your browser is not suitable for live based on webRTC, please use the latest Chrome.'

    /**
     * 抽奖
     */

    exports.LOTTERY_STATUS_ING = 'In the lottery, rest'

    exports.LOTTERY_COMMADN_ING_TIP = 'The lottery is still in progress, whether to publish the winning list.'

    exports.LOTTERY_BUTTON_CONTINUE = 'Continue'

    exports.LOTTERY_BUTTON_BEGIN_NOW = 'Now'

    exports.LOTTERY_BEGIN_IN_CHAT = 'Enter the command in the chat area to participate in the lottery.'

    exports.LOTTERY_MESSAGE_TIP_BEFORE = 'Input'

    exports.LOTTERY_MESSAGE_TIP_AFTER = 'Draw'

    /**
     * 音频设备统一切换
     */
    exports.COMBINED_AUDIO_DEVICE_SWITCH_CONFIRM = 'Are you willing to use the same device\'s microphone/speaker?'

    exports.COMBINED_AUDIO_DEVICE_SWITCH_OK = 'Use It'

    /*
     * 授权画笔
     */
    exports.PAINT_AUTHORIZE_TIP_ENABLE = 'The teacher has authorized you to use the brush'

    exports.PAINT_AUTHORIZE_TIP_DISABLE = 'The teacher has taken back your brush permissions'

    /*
     * 切换布局
     */
    exports.SWITCH_LAYOUT_METTING = 'Switch to Gallery Layout'

    exports.SWITCH_LAYOUT_MONKEY = 'Switch to Monkey Layout'

    exports.CHECK_GRAYSCALE_FAIL = 'Switch environment fail, please contact 百家云 technical support'

    exports.SWITCH_LAYOUT_SINGLE = 'Switch to Single Layout'

    exports.DEVICE_IS_USING = 'The Device Is Using'

    exports.LINK_SHARE_SUCCESS = 'Links have been copied to the clipboard'

    exports.SHARE_LABEL_TITLE = 'Screen Share'

    exports.TEXT_NOTICE_LABEL_TITLE = 'Text Notice'

    exports.IMG_NOTICE_LABEL_TITLE = 'Img Notice'

    exports.USER_TAB_ALL = 'All User'

    exports.USER_TAB_FORBID = 'Forbidded User'

    exports.USER_TAB_KICKOUT = 'Kicked out User'

    exports.RECORD_COMPLETE_LIVE_TIP = 'Record finished,'

    exports.OPEN_RECORD_FILE = 'Open record file'

    exports.HTTP_REQUEST_ERROR = 'Http request fail, please check out your network'

    /*
     * 授权文档控制
     */
    exports.DOCUMENT_CONTROL_AUTHORIZE_TIP_ENABLE = 'The teacher has authorized you to control the document'

    exports.DOCUMENT_CONTROL_AUTHORIZE_TIP_DISABLE = 'The teacher has taken back your document permissions'

    exports.AUTH_MANAGEMENT_LABEL_TITLE = 'Auth Management'

    exports.TEXT_NO_SPEAK_AUTH = 'You can not speak because of no auth'

    exports.TEXT_SPEAK_AUTH_NO = 'The teacher has taken back your speak authority'

    exports.TEXT_NO_NOTICE_AUTH = 'You can not edit notice because of no auth'

    exports.TEXT_NOTICE_AUTH_NO = 'The teacher has taken back your notice authority'

    exports.TEXT_NO_DOCUMENT_UPLOAD_AUTH = 'You can not upload document because of no auth'

    exports.TEXT_DOCUMENT_UPLOAD_AUTH_NO = 'The teacher has taken back your upload document authority'

    exports.TEXT_NO_PAINTER_AUTH = 'You can not use painter because of no auth'

    exports.TEXT_PAINTER_AUTH_NO = 'The teacher has taken back your painter authority'

    exports.TEXT_NO_CLASS_START_END_AUTH = 'You can not start or end the class because of no auth'

    exports.TEXT_NO_CLOUD_RECORD_AUTH = 'You can not start or end cloud record because of no auth'

    exports.NO_RECORD_AUTH
        = 'To use the cloud recording function, you need to open the cloud on demand product line first.<br />'
        + 'Please contact the organization to open it！'

    exports.TEXT_NO_FORBID_AND_KICK_AUTH = 'You can not forbid and kick because of no auth'

    exports.TEXT_NO_QUIZ_AUTH = 'You currently do not have permission to publish the questionnaire'

    exports.CONFIRM_RELOAD = 'Confirm Reload？'

    exports.CONFIRM_CLOSE_ROOM
        = 'Comfirm Stop?</br>All users will be kicked out and live will be closed and no re-entry will be allowed.'

    exports.EXTENSION_LABEL_TITLE = 'Install ScreenShare Extension'

    exports.FORBID_LIVE = 'Stop'

    exports.AUTO_PLAY_TITLE = 'Entering '

    exports.PUBLISH_ERROR = 'Failed to publish video, please refresh'

    exports.SUBSCRIBE_ERROR = 'Failed to subscribe video, please refresh'

    exports.WEBRTC_SERVER_CONNECT_TIMEOUT = 'Connect timeout，please refresh'

    exports.SCREEN_SHARE_ERROR = 'Failed to share screen, please retry after refresh'

    exports.CAN_NOT_SCREEN_SHARE_WHEN_CLASS_END = 'You cannot share screen when class is end'

    exports.PPT_VIDEO_SWITCH_CONTENT_TIP
        = 'Switch the position of video window and whiteboard. Do students switch synchronously?'

    exports.PPT_VIDEO_SWITCH_LOCAL = 'Local switch only'

    exports.PPT_VIDEO_SWITCH_ALL = 'Synchronous switching'

    exports.CLASS_HISTORY_BACK_TIP = 'Back'

    exports.HISTORY_BACK_ALERT_TIP = 'Whether to leave the live room?'

    exports.RESULT_SCOPE_JINGXI = 'Gold'

    exports.TIP_ROOM_SERVER_LOGIN_KICKED_OUT = 'Yox has been kicked out by the teacher, unable switch class'

    exports.LOTTERY_TIME_STOP = 'Stop'

    exports.LOTTERY_TIME_STOP_TIP = 'Are you sure stop the lottery?'

    exports.TEXT_LOTTERY_SUCCESS = 'You\'re in the lottery, wait for the prize.'

    exports.TEXT_LOTTERY_COMMAND_FAIL = 'Command input error, please re-enter'

    exports.TEXT_LOTTERY_CLOSE_NO_SUBMIT = 'You are not submit info, sure to close?'

    exports.TEXT_LOTTERY_TEACHER_OPENED = 'The lottery is currently in progress.'

    exports.TEXT_VOTE_TEACHER_OPENED = 'The vote is currently in progress.'

    exports.TEXT_TEACHER_TITLE = 'Start Vote'

    exports.CLASS_STATUS_STOP_WARMING_UP = 'Stop WarmingUp'

    exports.TEXT_DETELE_WHITEBOARD = 'Do you delete the current whiteboard and content?'

    exports.INFO_PLAYER_LOW_UPLINK_AUDIO_BANDWIDTH
        = 'The system detects that your microphone is working abnormally. Please reconnect the device.'

    exports.INFO_RED_PACKET_CREATE_FAIL = 'Create red packet fail'

    exports.CLEAR_ALL_SHAPE_TIP
        = '<p><icon>!</icon>Are you sure you want to clear them all?</p><p>This operation will clear all editing and annotation contents and cannot be recovered. Please operate carefully!</p>'

    exports.CLEAR_ALL_SHAPE_OK_TIP = 'Clear All'

    exports.CAN_NOT_PUSH_WEBRTC_STREAM
        = 'The current browser does not support speaking. Please use the latest chrome or client'

    exports.TEXT_FORBID_CLASS_START_END = 'Class time is not up'

    exports.CONFIRM_EXIT_CLASSROOM_FORBID_END_CLASS = 'It\'s not the end time, do you still want to exit?'

    exports.CONFIRM_LOCATE_PREV_PAGE_END_CLASS
        = 'Returning to the previous page will automatically end the class. Do you want to return?'

    exports.CONFIRM_LOCATE_PREV_PAGE_EXIT_CLASSROOM
        = 'Returning to the previous page will exit the classroom immediately. Do you want to return?'

    exports.BUTTON_SWITCH_MIX_MAIN_USER = 'Switch video layout'

    exports.TITLE_SIWTCH_MIX_MAIN_USER
        = 'After switching, the video screen that the students see will be displayed synchronously'

    exports.MIX_USER_SCREEN_CHANGE_TIP = '${userName} has been switched to the main screen'

    exports.LOTTERY_HISTORY_LIST = 'Lottery History'

    /**
     * 低版本 app 不支持作业功能提示
     */
    exports.ALERT_TITLE = 'Tip'

    exports.ALERT_FIND_LOW_VERSION_APP_IN_CLASS_NOT_SUPPORT_HOMEWORK
        = 'The mobile terminal does not support this function temporarily.'

    exports.TIP_I_KONW = 'I konw'

    exports.BUTTON_AUTHORIZE_H5_PPT = 'Authorize H5 PPT'

    exports.BUTTON_AUTHORIZE_H5_PPT_OFF = 'Cancel authorize'

    exports.TIP_AUTHORIZE_H5_PPT_ON = 'Authorize all students operate H5 PPT'

    exports.TIP_AUTHORIZE_H5_PPT_OFF = 'Cancel authorize all students operate H5 PPT'

    exports.WEBRTC_TYPE_CHANGE_TIP = 'This room has switched lines and will re-enter the room soon, please wait ...'

    exports.TIP_DISABLE_CONTROLL_FORBID_ALL = 'The teacher has forbid all'

    exports.TIP_NOT_ALLOW_AUTHORIZE_H5_PPT
        = 'You have banned students from turning pages and cannot authorize courseware'

    exports.TIP_CANCEL_AUTHORIZE_H5_PPT
        = 'You prohibit students from turning pages, and the courseware authorization has been cancelled'

    /**
     * safari flv 拉流提示
     */
    exports.LABEL_SAFARI_FLV_PULL_TIPS
        = 'Can\'t get live audio and video? Open this site settings... in Safari browser and set autoplay to allow all autoplay.'

    /**
     * =================================================
     * 外接手机摄像头
     * =================================================
     */
    exports.DIALOG_TITLE_PHONE_CAMERA_QRCODE = 'Scan code live video'

    exports.TIP_USE_PHONE_CAMERA_QRCODE = 'use yunduanketang app to scan the code'

    exports.DIALOG_TITLE_STOP_PHONE_CAMERA = 'stop phone camera'

    exports.TIP_OPEN_MAIN_CAMERA = 'open main camera'

    /**
     * 屏幕共享音源选择
     */
    exports.SCREEN_SHARE_AUDIO_SELECT_TITLE = 'Select sound source'

    exports.SCREEN_SHARE_AUDIO_SELECT_MIC = 'Share microphone sound'

    exports.SCREEN_SHARE_AUDIO_SELECT_MIC_TIPS
        = 'When the screen is shared, students will hear the sound of your microphone'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM = 'Share system sound'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM_TIPS_1 = 'When the screen is shared, students will hear your system sound'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM_TIPS_2 = '(for example: QQ message prompt, music, video playback, etc.)'

    /**
     * =================================================
     * 美颜
     * =================================================
     */
    exports.DIALOG_TITLE_CLIP_IMAGE = 'Clip Image'

    exports.TIP_INIT_BEAUTY_FAIL = 'Beauty program initialization failed'

    exports.SETTING_LABEL_BEAUTY = 'Beauty'

    exports.SETTING_LABEL_VIRTUAL_BG = 'VirtualBackground'

    exports.SETTING_TIP_WEB_BEAUTY
        = 'Beauty <br/> 1. Opening beauty filter will occupy a certain amount of memory and CPU<br/> 2. In order to avoid getting stuck when using beauty on the web, please turn on hardware acceleration<br/> 3. If you need to use more beauty & virtual background advanced effects, please open it in the background and use it on the client!'

    /**
     * =================================================
     * 选择显身 / 隐身
     * =================================================
     */
    exports.LABEL_ASSISTANT_VISIBLE_TIPS
        = 'If you are a classroom teaching assistant, please use your personal identity to enter. Others can see you'

    exports.LABEL_ASSISTANT_HIDDEN_TIPS
        = 'If you are a class supervisor or tour assistant, please use your invisible identity to enter. No one else can see you'

    exports.LABEL_ASSISTANT_ENTER = 'enter'

    /**
     * =================================================
     * 摄像机采集模式切换
     * =================================================
     */
    exports.HINT_CLIENT_VIDEO_CAPTURE_MODE_CHANGE_DIALOG_TEXT
        = 'Restart required to change video capture mode, restart now?'

    /**
     * =================================================
     * 积分
     * =================================================
     */
    exports.BONUS_BUBBLE_TIP = 'points'

    exports.BONUS_MY_POINTS = 'My Points'

    exports.BONUS_POINTS_RANK = 'Points Rank'

    exports.BONUS_POINTS_NOT_ENOUNGH = 'Points are not enough for this operation, no points will be issued temporarily'

    /**
     * =================================================
     * 智写云笔手写板
     * =================================================
     */
    exports.TIP_HAND_WRITTING_BOARD_CONNECTED = 'The handwriting board is connected successfully'

    exports.TIP_HAND_WRITTING_BOARD_DISCONNECTED = 'The handwriting board has been disconnected'

    exports.TIP_HAND_WRITTING_BOARD_SLEEP
        = 'The writing board is sleeping, please press the power button on the external writing board to wake up the device'

    exports.CONFIRM_TITLE_HAND_WRITTING_BOARD_BEFORE_DISCONNECT = 'Confirm'

    exports.CONFIRM_CONTENT_HAND_WRITTING_BOARD_BEFORE_DISCONNECT
        = 'Whether to disconnect the connection with handwriting board'

    exports.CANVAS_SWITCH_TO_WHITEBOARD = 'Switch to whiteboard'

    exports.CANVAS_SWITCH_TO_DOCUMENT = 'Switch to document: ${name}'

    /**
     * =================================================
     * 抢答器
     * =================================================
     */
    exports.TIP_USER_OFFLINE = 'The student is not in class'

    exports.TIP_USER_ON_STAGE_ALREADY = 'The student is speaking'

    exports.TIP_NOT_ALLOW_SPEAK = 'The current live broadcast does not support playing'

    /**
     * =================================================
     * 检测录制
     * =================================================
     */
    exports.TIP_RECORD_SOFTWARE_CHECKED
        = 'The program detects that you are recording the screen. Please close the screen recording software and restart the client for viewing'

    /**
     * =================================================
     * 转播
     * =================================================
     */
    exports.INFO_CAN_NOT_OPERATE_MEDIA_WHEN_TRANSFER_CLASS
        = 'You can\'t operate related operations of audio and video and management courseware during rebroadcasting'

    exports.CONFIRM_END_TRANSFER_CLASS = 'Broadcasting is in progress. Are you sure to turn off broadcasting?'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_TRANSFER_CLASS_END = 'Media cannot be used before the end of broadcasting~'

    exports.INFO_CAN_NOT_START_TRANSFER_CLASS_BEFORE_START_CLASS = 'The course has not started and cannot be broadcast~'

    exports.CAN_NOT_STOP_RTMP_PUSH_WHEN_TRANSFER_CLASS_BEGIN = 'The retransmission function cannot be banned'

    exports.COMMON_ERROR_PAGE_TIP_PREFIX = ''

    /**
     * =================================================
     * 打开摄像头提示
     * =================================================
     */
    exports.INFO_IF_OPEN_CAMERA = 'Whether to turn on the camera？'

    exports.BUTTON_NOT_OPEN_CAMERA = 'Don\'t open'

    exports.BUTTON_OPEN_CAMERA = 'open'

    /**
     * =================================================
     * 字幕
     * =================================================
     */
    exports.BUTTON_CAPTION = 'subtitle'

    exports.BUTTON_CLOSE_CAPTION = 'Close subtitles'

    /**
     * =================================================
     * 福袋
     * =================================================
     */
    exports.TIP_END_LUCKY_BAG = 'If the blessing bag stops, it cannot be recovered. Please operate with caution'

    /**
     * =================================================
     * PK 功能
     * =================================================
     */
    exports.TIP_PK_USER_NOT_ENOUGH = 'Insufficient number of speakers'

    exports.TIP_PK_USER_OUT = 'Has exited the classroom, please reset the PK member'

    /**
     * =================================================
     * 打开网页
     * =================================================
     */
    exports.TIP_CLOSE_WEB_PAGE = 'Close operation will retrieve the student\'s page, confirm to continue?'

    exports.TIP_PAGE_CANCEL = 'Page is closed'

    exports.MANAGE_EXPLORER = 'Browser'

    exports.ELECTRON_CLIENT_AVSDK_CAN_NOT_PUSH_STREAM_TIP = 'The Electron version does not support the use of the current audio and video bottom streaming, please go to the official website to download the CEF version for use!'

    /**
     * =================================================
     * 白板导出
     * =================================================
     */
    exports.BLACKBOARD_EXPORT = 'Save the blackboard'

    /**
     * =================================================
     * 自定义推流布局
     * =================================================
     */
    exports.VIDEO_LAYOUT_SETTING = 'Customize streaming layout'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_CLOSE_VIDEO_LAYOUT = 'Cannot play media before closing custom streaming layout'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_VIDEO_LAYOUT = 'Screen sharing cannot be used until custom streaming layout is closed'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_SCREEN_SHARE = 'Custom streaming layout cannot be used until screen sharing is turned off'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_MEDIA_FILE = 'Custom streaming layout cannot be used until video is closed'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_PLAYBACK = 'Custom streaming layout cannot be used before playback is closed'

    exports.INFO_PUBLISH_VIDEO_LAYOUT_SHOULD_BE_PRESENTER = 'Only the speaker can use the custom streaming layout'

    /**
     * =================================================
     * 切换 WebRTC 节点
     * =================================================
     */
    exports.BUTTON_SWITCH_WEBRTC_NODE = 'Switch WebRTC Node'

    exports.INFO_CAN_NOT_SWITCH_WEBRTC_NODE_IN_WEBRTC_MIX = 'Can\'t switch WebRTC Node before media on'

    /**
     * =================================================
     * 本地录制提示
     * =================================================
     */
    exports.INFO_CONFIRM_STOP_LOCAL_RECORD = 'Local recording is in progress. Are you sure you want to stop local recording?'

    exports.INFO_LOCAL_RECORD_GENERATE = 'Local recorded video generation is in progress and cannot leave the live broadcast room.'

    exports.INFO_LOCAL_RECORD_HAS_GENERATE = 'The locally recorded video has been generated.'

    /**
     * =================================================
     *  推荐卡片
     * =================================================
     */
    exports.TITLE_RECOMMEND_CARD = 'Recommendation Card'

    /**
     * =================================================
     *  申请开麦
     * =================================================
     */
    exports.MIC_APPLY_DESC = 'Apply to turn on the microphone'

    exports.MIC_REJECT_TIP = 'The teacher has rejected the microphone application'

    exports.MIC_ACCEPT_TIP = 'The teacher has approved the microphone application'

    exports.TIP_ON_WALL = 'Your message has been selected to be on the blackboard!'

    /**
     * =================================================
     *  cpu 提示
     * =================================================
     */
    exports.TIP_CPU_HIGH_LIMIT_SCREEN_SHARE = "The system has detected that the current CPU exceeds 70%. Using 'screen sharing' will cause live streaming abnormalities and is not supported!"

    exports.TIP_CPU_HIGH_LIMIT_BEAUTY = "The system detects that the current CPU exceeds 70%. Enabling 'Beauty/Virtual Background'  will cause abnormal live streaming and is not supported!"

    exports.TIP_CPU_HIGH_END_SCREEN_SHARE = "The system has detected that the current CPU is over 80%, and using 'screen sharing' will cause abnormal live streaming. Sharing has been interrupted for you!"

    exports.TIP_CPU_HIGH_END_BEAUTY = "The system has detected that the current CPU is over 80%. Continuing to use 'Beauty/Virtual Background' will cause abnormal live streaming. It has been turned off for you!"
})
